// KR 종목 마스터 (종목명→코드→시장). scripts/update-kr-master.mjs가 네이버
// 시가총액 목록에서 생성한다. 손으로 고치지 말고 스크립트를 다시 돌릴 것.
// 마지막 갱신: 2026-08-20 · 2765종목 (ETN 제외)
// m: KS=코스피, KQ=코스닥
export const KR_STOCKS = [
  {n:"3S",c:"060310",m:"KQ"},
  {n:"AJ네트웍스",c:"095570",m:"KS"},
  {n:"AK홀딩스",c:"006840",m:"KS"},
  {n:"APS",c:"054620",m:"KQ"},
  {n:"APS이노베이션",c:"079810",m:"KQ"},
  {n:"AP시스템",c:"265520",m:"KQ"},
  {n:"AP위성",c:"211270",m:"KQ"},
  {n:"BGF",c:"027410",m:"KS"},
  {n:"BGF리테일",c:"282330",m:"KS"},
  {n:"BGF에코머티리얼즈",c:"126600",m:"KQ"},
  {n:"BNK금융지주",c:"138930",m:"KS"},
  {n:"BYC",c:"001460",m:"KS"},
  {n:"BYC우",c:"001465",m:"KS"},
  {n:"CG인바이츠",c:"083790",m:"KQ"},
  {n:"CJ",c:"001040",m:"KS"},
  {n:"CJ CGV",c:"079160",m:"KS"},
  {n:"CJ ENM",c:"035760",m:"KQ"},
  {n:"CJ 바이오사이언스",c:"311690",m:"KQ"},
  {n:"CJ4우(전환)",c:"00104K",m:"KS"},
  {n:"CJ대한통운",c:"000120",m:"KS"},
  {n:"CJ씨푸드",c:"011150",m:"KS"},
  {n:"CJ씨푸드1우",c:"011155",m:"KS"},
  {n:"CJ우",c:"001045",m:"KS"},
  {n:"CJ제일제당",c:"097950",m:"KS"},
  {n:"CJ제일제당 우",c:"097955",m:"KS"},
  {n:"CJ프레시웨이",c:"051500",m:"KQ"},
  {n:"CMG제약",c:"058820",m:"KQ"},
  {n:"CNT85",c:"056730",m:"KQ"},
  {n:"CR홀딩스",c:"000480",m:"KS"},
  {n:"CS",c:"065770",m:"KQ"},
  {n:"CSA 코스믹",c:"083660",m:"KQ"},
  {n:"CS홀딩스",c:"000590",m:"KS"},
  {n:"DB",c:"012030",m:"KS"},
  {n:"DB금융스팩12호",c:"477760",m:"KQ"},
  {n:"DB손해보험",c:"005830",m:"KS"},
  {n:"DB증권",c:"016610",m:"KS"},
  {n:"DB하이텍",c:"000990",m:"KS"},
  {n:"DGI",c:"099520",m:"KQ"},
  {n:"DH오토넥스",c:"000300",m:"KS"},
  {n:"DH오토리드",c:"290120",m:"KQ"},
  {n:"DH오토웨어",c:"025440",m:"KQ"},
  {n:"DI동일",c:"001530",m:"KS"},
  {n:"DKME",c:"015590",m:"KS"},
  {n:"DL",c:"000210",m:"KS"},
  {n:"DL우",c:"000215",m:"KS"},
  {n:"DL이앤씨",c:"375500",m:"KS"},
  {n:"DL이앤씨2우(전환)",c:"37550L",m:"KS"},
  {n:"DL이앤씨우",c:"37550K",m:"KS"},
  {n:"DMS",c:"068790",m:"KQ"},
  {n:"DN오토모티브",c:"007340",m:"KS"},
  {n:"DRB동일",c:"004840",m:"KS"},
  {n:"DSC인베스트먼트",c:"241520",m:"KQ"},
  {n:"DSR",c:"155660",m:"KS"},
  {n:"DSR제강",c:"069730",m:"KS"},
  {n:"DS단석",c:"017860",m:"KS"},
  {n:"DXVX",c:"180400",m:"KQ"},
  {n:"DYP",c:"092780",m:"KS"},
  {n:"E1",c:"017940",m:"KS"},
  {n:"E8",c:"418620",m:"KQ"},
  {n:"EDGC",c:"245620",m:"KQ"},
  {n:"EG",c:"037370",m:"KQ"},
  {n:"ESR켄달스퀘어리츠",c:"365550",m:"KS"},
  {n:"ES큐브",c:"050120",m:"KQ"},
  {n:"F&F",c:"383220",m:"KS"},
  {n:"F&F홀딩스",c:"007700",m:"KS"},
  {n:"FSN",c:"214270",m:"KQ"},
  {n:"GC메디아이",c:"032620",m:"KQ"},
  {n:"GH신소재",c:"130500",m:"KQ"},
  {n:"GKL",c:"114090",m:"KS"},
  {n:"GMI벤처",c:"019570",m:"KQ"},
  {n:"GRT",c:"900290",m:"KQ"},
  {n:"GS",c:"078930",m:"KS"},
  {n:"GST",c:"083450",m:"KQ"},
  {n:"GS건설",c:"006360",m:"KS"},
  {n:"GS글로벌",c:"001250",m:"KS"},
  {n:"GS리테일",c:"007070",m:"KS"},
  {n:"GS우",c:"078935",m:"KS"},
  {n:"GS피앤엘",c:"499790",m:"KS"},
  {n:"HB솔루션",c:"297890",m:"KQ"},
  {n:"HB인베스트먼트",c:"440290",m:"KQ"},
  {n:"HB테크놀러지",c:"078150",m:"KQ"},
  {n:"HC보광산업",c:"225530",m:"KQ"},
  {n:"HC홈센타",c:"060560",m:"KQ"},
  {n:"HDC",c:"012630",m:"KS"},
  {n:"HDC랩스",c:"039570",m:"KS"},
  {n:"HDC현대EP",c:"089470",m:"KS"},
  {n:"HD건설기계",c:"267270",m:"KS"},
  {n:"HD한국조선해양",c:"009540",m:"KS"},
  {n:"HD현대",c:"267250",m:"KS"},
  {n:"HD현대마린솔루션",c:"443060",m:"KS"},
  {n:"HD현대마린엔진",c:"071970",m:"KS"},
  {n:"HD현대에너지솔루션",c:"322000",m:"KS"},
  {n:"HD현대일렉트릭",c:"267260",m:"KS"},
  {n:"HD현대중공업",c:"329180",m:"KS"},
  {n:"HEM파마",c:"376270",m:"KQ"},
  {n:"HJ중공업",c:"097230",m:"KS"},
  {n:"HK이노엔",c:"195940",m:"KQ"},
  {n:"HL D&I",c:"014790",m:"KS"},
  {n:"HLB",c:"028300",m:"KQ"},
  {n:"HLB글로벌",c:"003580",m:"KS"},
  {n:"HLB바이오스텝",c:"278650",m:"KQ"},
  {n:"HLB생명과학",c:"067630",m:"KQ"},
  {n:"HLB이노베이션",c:"024850",m:"KQ"},
  {n:"HLB제넥스",c:"187420",m:"KQ"},
  {n:"HLB제약",c:"047920",m:"KQ"},
  {n:"HLB테라퓨틱스",c:"115450",m:"KQ"},
  {n:"HLB파나진",c:"046210",m:"KQ"},
  {n:"HLB펩",c:"196300",m:"KQ"},
  {n:"HL만도",c:"204320",m:"KS"},
  {n:"HL홀딩스",c:"060980",m:"KS"},
  {n:"HMM",c:"011200",m:"KS"},
  {n:"HPSP",c:"403870",m:"KQ"},
  {n:"HRS",c:"036640",m:"KQ"},
  {n:"HS애드",c:"035000",m:"KS"},
  {n:"HS화성",c:"002460",m:"KS"},
  {n:"HS효성",c:"487570",m:"KS"},
  {n:"HS효성첨단소재",c:"298050",m:"KS"},
  {n:"IBKS제24호스팩",c:"469480",m:"KQ"},
  {n:"IBKS제25호스팩",c:"0099X0",m:"KQ"},
  {n:"INVENI",c:"015360",m:"KS"},
  {n:"IPARK현대산업개발",c:"294870",m:"KS"},
  {n:"ISC",c:"095340",m:"KQ"},
  {n:"JB금융지주",c:"175330",m:"KS"},
  {n:"JTC",c:"950170",m:"KQ"},
  {n:"JW생명과학",c:"234080",m:"KS"},
  {n:"JW신약",c:"067290",m:"KQ"},
  {n:"JW중외제약",c:"001060",m:"KS"},
  {n:"JW중외제약2우B",c:"001067",m:"KS"},
  {n:"JW중외제약우",c:"001065",m:"KS"},
  {n:"JW홀딩스",c:"096760",m:"KS"},
  {n:"JYP Ent.",c:"035900",m:"KQ"},
  {n:"KBG",c:"318000",m:"KQ"},
  {n:"KBI동양철관",c:"008970",m:"KS"},
  {n:"KBI메탈",c:"024840",m:"KQ"},
  {n:"KB금융",c:"105560",m:"KS"},
  {n:"KB발해인프라",c:"415640",m:"KS"},
  {n:"KB스타리츠",c:"432320",m:"KS"},
  {n:"KB오토시스",c:"024120",m:"KQ"},
  {n:"KB제29호스팩",c:"478390",m:"KQ"},
  {n:"KB제30호스팩",c:"486630",m:"KQ"},
  {n:"KB제31호스팩",c:"492220",m:"KQ"},
  {n:"KB제32호스팩",c:"0037T0",m:"KQ"},
  {n:"KB제33호스팩",c:"0072Z0",m:"KQ"},
  {n:"KCC",c:"002380",m:"KS"},
  {n:"KCC건설",c:"021320",m:"KQ"},
  {n:"KCC글라스",c:"344820",m:"KS"},
  {n:"KCTC",c:"009070",m:"KS"},
  {n:"KC그린홀딩스",c:"009440",m:"KS"},
  {n:"KC코트렐",c:"119650",m:"KS"},
  {n:"KD",c:"044180",m:"KQ"},
  {n:"KEC",c:"092220",m:"KS"},
  {n:"KG모빌리티",c:"003620",m:"KS"},
  {n:"KG스틸",c:"016380",m:"KS"},
  {n:"KG에코솔루션",c:"151860",m:"KQ"},
  {n:"KG이니시스",c:"035600",m:"KQ"},
  {n:"KG케미칼",c:"001390",m:"KS"},
  {n:"KG파이낸셜",c:"046440",m:"KQ"},
  {n:"KH바텍",c:"060720",m:"KQ"},
  {n:"KISCO홀딩스",c:"001940",m:"KS"},
  {n:"KNN",c:"058400",m:"KQ"},
  {n:"KPX케미칼",c:"025000",m:"KS"},
  {n:"KPX홀딩스",c:"092230",m:"KS"},
  {n:"KR모터스",c:"000040",m:"KS"},
  {n:"KSS해운",c:"044450",m:"KS"},
  {n:"KS인더스트리",c:"101000",m:"KQ"},
  {n:"KT",c:"030200",m:"KS"},
  {n:"KT&G",c:"033780",m:"KS"},
  {n:"KTcs",c:"058850",m:"KS"},
  {n:"KTis",c:"058860",m:"KS"},
  {n:"KT나스미디어",c:"089600",m:"KQ"},
  {n:"KT밀리의서재",c:"418470",m:"KQ"},
  {n:"KT지니뮤직",c:"043610",m:"KQ"},
  {n:"KX",c:"122450",m:"KQ"},
  {n:"KX하이텍",c:"052900",m:"KQ"},
  {n:"KZ정밀",c:"036560",m:"KQ"},
  {n:"LB세미콘",c:"061970",m:"KQ"},
  {n:"LB인베스트먼트",c:"309960",m:"KQ"},
  {n:"LF",c:"093050",m:"KS"},
  {n:"LG",c:"003550",m:"KS"},
  {n:"LG디스플레이",c:"034220",m:"KS"},
  {n:"LG생활건강",c:"051900",m:"KS"},
  {n:"LG생활건강우",c:"051905",m:"KS"},
  {n:"LG씨엔에스",c:"064400",m:"KS"},
  {n:"LG에너지솔루션",c:"373220",m:"KS"},
  {n:"LG우",c:"003555",m:"KS"},
  {n:"LG유플러스",c:"032640",m:"KS"},
  {n:"LG이노텍",c:"011070",m:"KS"},
  {n:"LG전자",c:"066570",m:"KS"},
  {n:"LG전자우",c:"066575",m:"KS"},
  {n:"LG헬로비전",c:"037560",m:"KS"},
  {n:"LG화학",c:"051910",m:"KS"},
  {n:"LG화학우",c:"051915",m:"KS"},
  {n:"LIG디펜스앤에어로스페이스",c:"079550",m:"KS"},
  {n:"LIG아큐버",c:"073490",m:"KQ"},
  {n:"LK삼양",c:"225190",m:"KQ"},
  {n:"LS",c:"006260",m:"KS"},
  {n:"LS ELECTRIC",c:"010120",m:"KS"},
  {n:"LSK아이로봇",c:"091970",m:"KQ"},
  {n:"LS네트웍스",c:"000680",m:"KS"},
  {n:"LS마린솔루션",c:"060370",m:"KQ"},
  {n:"LS머트리얼즈",c:"417200",m:"KQ"},
  {n:"LS에코에너지",c:"229640",m:"KS"},
  {n:"LS증권",c:"078020",m:"KQ"},
  {n:"LS티라유텍",c:"322180",m:"KQ"},
  {n:"LX세미콘",c:"108320",m:"KS"},
  {n:"LX인터내셔널",c:"001120",m:"KS"},
  {n:"LX하우시스",c:"108670",m:"KS"},
  {n:"LX하우시스우",c:"108675",m:"KS"},
  {n:"LX홀딩스",c:"383800",m:"KS"},
  {n:"LX홀딩스1우",c:"38380K",m:"KS"},
  {n:"M83",c:"476080",m:"KQ"},
  {n:"MDS테크",c:"086960",m:"KQ"},
  {n:"MH에탄올",c:"023150",m:"KS"},
  {n:"NAVER",c:"035420",m:"KS"},
  {n:"NC",c:"036570",m:"KS"},
  {n:"NEW",c:"160550",m:"KQ"},
  {n:"NE능률",c:"053290",m:"KQ"},
  {n:"NHN",c:"181710",m:"KS"},
  {n:"NHN KCP",c:"060250",m:"KQ"},
  {n:"NHN벅스",c:"104200",m:"KQ"},
  {n:"NH농우바이오",c:"054050",m:"KQ"},
  {n:"NH올원리츠",c:"400760",m:"KS"},
  {n:"NH투자증권",c:"005940",m:"KS"},
  {n:"NH투자증권우",c:"005945",m:"KS"},
  {n:"NH프라임리츠",c:"338100",m:"KS"},
  {n:"NICE",c:"034310",m:"KS"},
  {n:"NICE인프라",c:"063570",m:"KQ"},
  {n:"NICE평가정보",c:"030190",m:"KS"},
  {n:"NI스틸",c:"008260",m:"KS"},
  {n:"NPC",c:"004250",m:"KS"},
  {n:"NPC우",c:"004255",m:"KS"},
  {n:"OCI",c:"456040",m:"KS"},
  {n:"OCI홀딩스",c:"010060",m:"KS"},
  {n:"PI첨단소재",c:"178920",m:"KS"},
  {n:"PKC",c:"001340",m:"KS"},
  {n:"PN풍년",c:"024940",m:"KQ"},
  {n:"POSCO홀딩스",c:"005490",m:"KS"},
  {n:"PS일렉트로닉스",c:"332570",m:"KQ"},
  {n:"RFHIC",c:"218410",m:"KQ"},
  {n:"RF머트리얼즈",c:"327260",m:"KQ"},
  {n:"RF시스템즈",c:"474610",m:"KQ"},
  {n:"S&K폴리텍",c:"091340",m:"KQ"},
  {n:"S-Oil",c:"010950",m:"KS"},
  {n:"S-Oil우",c:"010955",m:"KS"},
  {n:"SAMG엔터",c:"419530",m:"KQ"},
  {n:"SBI인베스트먼트",c:"019550",m:"KQ"},
  {n:"SBS",c:"034120",m:"KS"},
  {n:"SB성보",c:"003080",m:"KS"},
  {n:"SCL사이언스",c:"246960",m:"KQ"},
  {n:"SDN",c:"099220",m:"KQ"},
  {n:"SFA",c:"056190",m:"KQ"},
  {n:"SFA넥셀",c:"222080",m:"KQ"},
  {n:"SFA반도체",c:"036540",m:"KQ"},
  {n:"SG",c:"255220",m:"KQ"},
  {n:"SG&G",c:"040610",m:"KQ"},
  {n:"SGA솔루션즈",c:"184230",m:"KQ"},
  {n:"SGC E&C",c:"016250",m:"KQ"},
  {n:"SGC에너지",c:"005090",m:"KS"},
  {n:"SG글로벌",c:"001380",m:"KS"},
  {n:"SG세계물산",c:"004060",m:"KS"},
  {n:"SHD",c:"001770",m:"KS"},
  {n:"SH에너지화학",c:"002360",m:"KS"},
  {n:"SIMPAC",c:"009160",m:"KS"},
  {n:"SJG세종",c:"033530",m:"KS"},
  {n:"SJM",c:"123700",m:"KS"},
  {n:"SJM홀딩스",c:"025530",m:"KS"},
  {n:"SK",c:"034730",m:"KS"},
  {n:"SKAI",c:"357880",m:"KQ"},
  {n:"SKC",c:"011790",m:"KS"},
  {n:"SK가스",c:"018670",m:"KS"},
  {n:"SK네트웍스",c:"001740",m:"KS"},
  {n:"SK디스커버리",c:"006120",m:"KS"},
  {n:"SK디스커버리우",c:"006125",m:"KS"},
  {n:"SK디앤디",c:"210980",m:"KS"},
  {n:"SK리츠",c:"395400",m:"KS"},
  {n:"SK바이오사이언스",c:"302440",m:"KS"},
  {n:"SK바이오팜",c:"326030",m:"KS"},
  {n:"SK스퀘어",c:"402340",m:"KS"},
  {n:"SK아이이테크놀로지",c:"361610",m:"KS"},
  {n:"SK오션플랜트",c:"100090",m:"KS"},
  {n:"SK우",c:"03473K",m:"KS"},
  {n:"SK이노베이션",c:"096770",m:"KS"},
  {n:"SK이노베이션우",c:"096775",m:"KS"},
  {n:"SK이터닉스",c:"475150",m:"KS"},
  {n:"SK증권",c:"001510",m:"KS"},
  {n:"SK증권우",c:"001515",m:"KS"},
  {n:"SK케미칼",c:"285130",m:"KS"},
  {n:"SK케미칼우",c:"28513K",m:"KS"},
  {n:"SK텔레콤",c:"017670",m:"KS"},
  {n:"SK하이닉스",c:"000660",m:"KS"},
  {n:"SM C&C",c:"048550",m:"KQ"},
  {n:"SM Life Design",c:"063440",m:"KQ"},
  {n:"SNT다이내믹스",c:"003570",m:"KS"},
  {n:"SNT모티브",c:"064960",m:"KS"},
  {n:"SNT에너지",c:"100840",m:"KS"},
  {n:"SNT홀딩스",c:"036530",m:"KS"},
  {n:"SOOP",c:"067160",m:"KQ"},
  {n:"SP삼화",c:"000390",m:"KS"},
  {n:"STX",c:"011810",m:"KS"},
  {n:"STX그린로지스",c:"465770",m:"KS"},
  {n:"STX엔진",c:"077970",m:"KS"},
  {n:"SUN&L",c:"002820",m:"KS"},
  {n:"SV인베스트먼트",c:"289080",m:"KQ"},
  {n:"SYTS",c:"002170",m:"KS"},
  {n:"SY동아",c:"041930",m:"KQ"},
  {n:"TBH글로벌",c:"084870",m:"KS"},
  {n:"TCC스틸",c:"002710",m:"KS"},
  {n:"THE E&M",c:"089230",m:"KQ"},
  {n:"TJ미디어",c:"032540",m:"KQ"},
  {n:"TKG휴켐스",c:"069260",m:"KS"},
  {n:"TP",c:"007980",m:"KS"},
  {n:"TPC로보틱스",c:"048770",m:"KQ"},
  {n:"TS인베스트먼트",c:"246690",m:"KQ"},
  {n:"TS트릴리온",c:"317240",m:"KQ"},
  {n:"TYM",c:"002900",m:"KS"},
  {n:"WISCOM",c:"024070",m:"KS"},
  {n:"YBM넷",c:"057030",m:"KQ"},
  {n:"YG PLUS",c:"037270",m:"KS"},
  {n:"YTN",c:"040300",m:"KQ"},
  {n:"YW",c:"051390",m:"KQ"},
  {n:"iMBC",c:"052220",m:"KQ"},
  {n:"iM금융지주",c:"139130",m:"KS"},
  {n:"가비아",c:"079940",m:"KQ"},
  {n:"가온그룹",c:"078890",m:"KQ"},
  {n:"가온전선",c:"000500",m:"KS"},
  {n:"가온칩스",c:"399720",m:"KQ"},
  {n:"감성코퍼레이션",c:"036620",m:"KQ"},
  {n:"강남제비스코",c:"000860",m:"KS"},
  {n:"강동씨앤엘",c:"198440",m:"KQ"},
  {n:"강스템바이오텍",c:"217730",m:"KQ"},
  {n:"강원랜드",c:"035250",m:"KS"},
  {n:"강원에너지",c:"114190",m:"KQ"},
  {n:"갤럭시아머니트리",c:"094480",m:"KQ"},
  {n:"갤럭시아에스엠",c:"011420",m:"KS"},
  {n:"경남스틸",c:"039240",m:"KQ"},
  {n:"경남제약",c:"053950",m:"KQ"},
  {n:"경농",c:"002100",m:"KS"},
  {n:"경동나비엔",c:"009450",m:"KS"},
  {n:"경동도시가스",c:"267290",m:"KS"},
  {n:"경동인베스트",c:"012320",m:"KS"},
  {n:"경동제약",c:"011040",m:"KQ"},
  {n:"경방",c:"000050",m:"KS"},
  {n:"경보제약",c:"214390",m:"KS"},
  {n:"경인양행",c:"012610",m:"KS"},
  {n:"경인전자",c:"009140",m:"KS"},
  {n:"경창산업",c:"024910",m:"KQ"},
  {n:"계룡건설",c:"013580",m:"KS"},
  {n:"계양전기",c:"012200",m:"KS"},
  {n:"계양전기우",c:"012205",m:"KS"},
  {n:"고려산업",c:"002140",m:"KS"},
  {n:"고려신용정보",c:"049720",m:"KQ"},
  {n:"고려아연",c:"010130",m:"KS"},
  {n:"고려제강",c:"002240",m:"KS"},
  {n:"고려제약",c:"014570",m:"KQ"},
  {n:"고바이오랩",c:"348150",m:"KQ"},
  {n:"고스트스튜디오",c:"950190",m:"KQ"},
  {n:"고영",c:"098460",m:"KQ"},
  {n:"골드앤에스",c:"035290",m:"KQ"},
  {n:"골프존",c:"215000",m:"KQ"},
  {n:"골프존홀딩스",c:"121440",m:"KQ"},
  {n:"광동제약",c:"009290",m:"KS"},
  {n:"광명전기",c:"017040",m:"KS"},
  {n:"광무",c:"029480",m:"KQ"},
  {n:"광전자",c:"017900",m:"KS"},
  {n:"광주신세계",c:"037710",m:"KS"},
  {n:"광진실업",c:"026910",m:"KQ"},
  {n:"교보15호스팩",c:"465320",m:"KQ"},
  {n:"교보16호스팩",c:"482520",m:"KQ"},
  {n:"교보17호스팩",c:"489210",m:"KQ"},
  {n:"교보18호스팩",c:"0041B0",m:"KQ"},
  {n:"교보19호스팩",c:"0098T0",m:"KQ"},
  {n:"교보20호스팩",c:"0132G0",m:"KQ"},
  {n:"교보증권",c:"030610",m:"KS"},
  {n:"교촌에프앤비",c:"339770",m:"KS"},
  {n:"구영테크",c:"053270",m:"KQ"},
  {n:"국도화학",c:"007690",m:"KS"},
  {n:"국보디자인",c:"066620",m:"KQ"},
  {n:"국순당",c:"043650",m:"KQ"},
  {n:"국영지앤엠",c:"006050",m:"KQ"},
  {n:"국일신동",c:"060480",m:"KQ"},
  {n:"국일제지",c:"078130",m:"KQ"},
  {n:"국전",c:"307750",m:"KQ"},
  {n:"국제약품",c:"002720",m:"KS"},
  {n:"그래디언트",c:"035080",m:"KQ"},
  {n:"그래피",c:"318060",m:"KQ"},
  {n:"그리드위즈",c:"453450",m:"KQ"},
  {n:"그리티",c:"204020",m:"KQ"},
  {n:"그린광학",c:"0015G0",m:"KQ"},
  {n:"그린리소스",c:"402490",m:"KQ"},
  {n:"그린생명과학",c:"114450",m:"KQ"},
  {n:"그린케미칼",c:"083420",m:"KS"},
  {n:"그린플러스",c:"186230",m:"KQ"},
  {n:"극동유화",c:"014530",m:"KS"},
  {n:"글로벌에스엠",c:"900070",m:"KQ"},
  {n:"글로벌텍스프리",c:"204620",m:"KQ"},
  {n:"글로본",c:"019660",m:"KQ"},
  {n:"금강공업",c:"014280",m:"KS"},
  {n:"금강공업우",c:"014285",m:"KS"},
  {n:"금강철강",c:"053260",m:"KQ"},
  {n:"금비",c:"008870",m:"KS"},
  {n:"금양",c:"001570",m:"KS"},
  {n:"금양그린파워",c:"282720",m:"KQ"},
  {n:"금호건설",c:"002990",m:"KS"},
  {n:"금호건설우",c:"002995",m:"KS"},
  {n:"금호석유화학",c:"011780",m:"KS"},
  {n:"금호석유화학우",c:"011785",m:"KS"},
  {n:"금호에이치티",c:"214330",m:"KS"},
  {n:"금호전기",c:"001210",m:"KS"},
  {n:"금호타이어",c:"073240",m:"KS"},
  {n:"금화피에스시",c:"036190",m:"KQ"},
  {n:"기가레인",c:"049080",m:"KQ"},
  {n:"기가비스",c:"420770",m:"KQ"},
  {n:"기산텔레콤",c:"035460",m:"KQ"},
  {n:"기신정기",c:"092440",m:"KS"},
  {n:"기아",c:"000270",m:"KS"},
  {n:"기업은행",c:"024110",m:"KS"},
  {n:"까뮤이앤씨",c:"013700",m:"KS"},
  {n:"깨끗한나라",c:"004540",m:"KS"},
  {n:"깨끗한나라우",c:"004545",m:"KS"},
  {n:"꿈비",c:"407400",m:"KQ"},
  {n:"나노",c:"187790",m:"KQ"},
  {n:"나노신소재",c:"121600",m:"KQ"},
  {n:"나노실리칸첨단소재",c:"286750",m:"KQ"},
  {n:"나노씨엠에스",c:"247660",m:"KQ"},
  {n:"나노엔텍",c:"039860",m:"KQ"},
  {n:"나노팀",c:"417010",m:"KQ"},
  {n:"나라셀라",c:"405920",m:"KQ"},
  {n:"나라스페이스테크놀로지",c:"478340",m:"KQ"},
  {n:"나라엠앤디",c:"051490",m:"KQ"},
  {n:"나래나노텍",c:"137080",m:"KQ"},
  {n:"나무가",c:"190510",m:"KQ"},
  {n:"나무에이엑스",c:"242040",m:"KQ"},
  {n:"나우IB",c:"293580",m:"KQ"},
  {n:"나우로보틱스",c:"459510",m:"KQ"},
  {n:"나이벡",c:"138610",m:"KQ"},
  {n:"나이스디앤비",c:"130580",m:"KQ"},
  {n:"나이스정보통신",c:"036800",m:"KQ"},
  {n:"나인앤컴퍼니",c:"366030",m:"KQ"},
  {n:"나인테크",c:"267320",m:"KQ"},
  {n:"남광토건",c:"001260",m:"KS"},
  {n:"남선알미늄",c:"008350",m:"KS"},
  {n:"남선알미우",c:"008355",m:"KS"},
  {n:"남성",c:"004270",m:"KS"},
  {n:"남양유업",c:"003920",m:"KS"},
  {n:"남양유업우",c:"003925",m:"KS"},
  {n:"남해화학",c:"025860",m:"KS"},
  {n:"남화산업",c:"111710",m:"KQ"},
  {n:"남화토건",c:"091590",m:"KQ"},
  {n:"내츄럴엔도텍",c:"168330",m:"KQ"},
  {n:"네오리진",c:"094860",m:"KQ"},
  {n:"네오뷰",c:"0218L0",m:"KQ"},
  {n:"네오셈",c:"253590",m:"KQ"},
  {n:"네오오토",c:"212560",m:"KQ"},
  {n:"네오위즈",c:"095660",m:"KQ"},
  {n:"네오위즈홀딩스",c:"042420",m:"KQ"},
  {n:"네오이뮨텍",c:"950220",m:"KQ"},
  {n:"네오크레마",c:"311390",m:"KQ"},
  {n:"네오티스",c:"085910",m:"KQ"},
  {n:"네오팜",c:"092730",m:"KQ"},
  {n:"네이블",c:"153460",m:"KQ"},
  {n:"네이처셀",c:"007390",m:"KQ"},
  {n:"네패스",c:"033640",m:"KQ"},
  {n:"네패스아크",c:"330860",m:"KQ"},
  {n:"넥사다이내믹스",c:"351320",m:"KQ"},
  {n:"넥센",c:"005720",m:"KS"},
  {n:"넥센우",c:"005725",m:"KS"},
  {n:"넥센타이어",c:"002350",m:"KS"},
  {n:"넥센타이어1우B",c:"002355",m:"KS"},
  {n:"넥스턴앤롤코리아",c:"089140",m:"KQ"},
  {n:"넥스트바이오메디컬",c:"389650",m:"KQ"},
  {n:"넥스트아이",c:"137940",m:"KQ"},
  {n:"넥스트칩",c:"396270",m:"KQ"},
  {n:"넥스틴",c:"348210",m:"KQ"},
  {n:"넥스틸",c:"092790",m:"KS"},
  {n:"넥슨게임즈",c:"225570",m:"KQ"},
  {n:"넥써쓰",c:"205500",m:"KQ"},
  {n:"넵튠",c:"217270",m:"KQ"},
  {n:"넷마블",c:"251270",m:"KS"},
  {n:"노랑풍선",c:"104620",m:"KQ"},
  {n:"노루페인트",c:"090350",m:"KS"},
  {n:"노루페인트우",c:"090355",m:"KS"},
  {n:"노루홀딩스",c:"000320",m:"KS"},
  {n:"노루홀딩스우",c:"000325",m:"KS"},
  {n:"노머스",c:"473980",m:"KQ"},
  {n:"노바렉스",c:"194700",m:"KQ"},
  {n:"노바텍",c:"285490",m:"KQ"},
  {n:"노브랜드",c:"145170",m:"KQ"},
  {n:"노을",c:"376930",m:"KQ"},
  {n:"노타",c:"486990",m:"KQ"},
  {n:"녹십자",c:"006280",m:"KS"},
  {n:"녹십자엠에스",c:"142280",m:"KQ"},
  {n:"녹십자웰빙",c:"234690",m:"KQ"},
  {n:"녹십자홀딩스",c:"005250",m:"KS"},
  {n:"녹십자홀딩스2우",c:"005257",m:"KS"},
  {n:"농심",c:"004370",m:"KS"},
  {n:"농심홀딩스",c:"072710",m:"KS"},
  {n:"누리플랜",c:"069140",m:"KQ"},
  {n:"누리플렉스",c:"040160",m:"KQ"},
  {n:"누보",c:"332290",m:"KQ"},
  {n:"뉴로메카",c:"348340",m:"KQ"},
  {n:"뉴로핏",c:"380550",m:"KQ"},
  {n:"뉴보텍",c:"060260",m:"KQ"},
  {n:"뉴엔AI",c:"463020",m:"KQ"},
  {n:"뉴온",c:"123840",m:"KQ"},
  {n:"뉴인텍",c:"012340",m:"KQ"},
  {n:"뉴키즈온",c:"462310",m:"KQ"},
  {n:"뉴트리",c:"270870",m:"KQ"},
  {n:"뉴파워프라즈마",c:"144960",m:"KQ"},
  {n:"뉴프렉스",c:"085670",m:"KQ"},
  {n:"다날",c:"064260",m:"KQ"},
  {n:"다보링크",c:"340360",m:"KQ"},
  {n:"다산네트웍스",c:"039560",m:"KQ"},
  {n:"다산디엠씨",c:"208860",m:"KQ"},
  {n:"다산솔루에타",c:"154040",m:"KQ"},
  {n:"다스코",c:"058730",m:"KS"},
  {n:"다올투자증권",c:"030210",m:"KS"},
  {n:"다우기술",c:"023590",m:"KS"},
  {n:"다우데이타",c:"032190",m:"KQ"},
  {n:"다원넥스뷰",c:"323350",m:"KQ"},
  {n:"다원시스",c:"068240",m:"KQ"},
  {n:"다이나믹디자인",c:"145210",m:"KS"},
  {n:"다이나믹솔루션",c:"290660",m:"KQ"},
  {n:"달바글로벌",c:"483650",m:"KS"},
  {n:"닷밀",c:"464580",m:"KQ"},
  {n:"대교",c:"019680",m:"KS"},
  {n:"대교우B",c:"019685",m:"KS"},
  {n:"대구백화점",c:"006370",m:"KS"},
  {n:"대덕",c:"008060",m:"KS"},
  {n:"대덕1우",c:"00806K",m:"KS"},
  {n:"대덕전자",c:"353200",m:"KS"},
  {n:"대덕전자1우",c:"35320K",m:"KS"},
  {n:"대동",c:"000490",m:"KS"},
  {n:"대동금속",c:"020400",m:"KQ"},
  {n:"대동기어",c:"008830",m:"KQ"},
  {n:"대동스틸",c:"048470",m:"KQ"},
  {n:"대륙제관",c:"004780",m:"KQ"},
  {n:"대림바스",c:"005750",m:"KS"},
  {n:"대림제지",c:"017650",m:"KQ"},
  {n:"대림통상",c:"006570",m:"KS"},
  {n:"대명에너지",c:"389260",m:"KQ"},
  {n:"대모",c:"317850",m:"KQ"},
  {n:"대보마그네틱",c:"290670",m:"KQ"},
  {n:"대봉엘에스",c:"078140",m:"KQ"},
  {n:"대산F&B",c:"065150",m:"KQ"},
  {n:"대상",c:"001680",m:"KS"},
  {n:"대상우",c:"001685",m:"KS"},
  {n:"대상홀딩스",c:"084690",m:"KS"},
  {n:"대상홀딩스우",c:"084695",m:"KS"},
  {n:"대성미생물",c:"036480",m:"KQ"},
  {n:"대성산업",c:"128820",m:"KS"},
  {n:"대성에너지",c:"117580",m:"KS"},
  {n:"대성창투",c:"027830",m:"KQ"},
  {n:"대성하이텍",c:"129920",m:"KQ"},
  {n:"대성홀딩스",c:"016710",m:"KS"},
  {n:"대신 KOSPI200인덱스 X클래스",c:"0106J0",m:"KS"},
  {n:"대신밸런스제17호스팩",c:"471050",m:"KQ"},
  {n:"대신밸런스제19호스팩",c:"482690",m:"KQ"},
  {n:"대신밸런스제20호스팩",c:"0134X0",m:"KQ"},
  {n:"대신밸류리츠",c:"0030R0",m:"KS"},
  {n:"대신정보통신",c:"020180",m:"KQ"},
  {n:"대신증권",c:"003540",m:"KS"},
  {n:"대신증권2우B",c:"003547",m:"KS"},
  {n:"대신증권우",c:"003545",m:"KS"},
  {n:"대아티아이",c:"045390",m:"KQ"},
  {n:"대양금속",c:"009190",m:"KS"},
  {n:"대양전기공업",c:"108380",m:"KQ"},
  {n:"대영포장",c:"014160",m:"KS"},
  {n:"대우건설",c:"047040",m:"KS"},
  {n:"대웅",c:"003090",m:"KS"},
  {n:"대웅제약",c:"069620",m:"KS"},
  {n:"대원",c:"007680",m:"KQ"},
  {n:"대원강업",c:"000430",m:"KS"},
  {n:"대원미디어",c:"048910",m:"KQ"},
  {n:"대원산업",c:"005710",m:"KQ"},
  {n:"대원전선",c:"006340",m:"KS"},
  {n:"대원전선우",c:"006345",m:"KS"},
  {n:"대원제약",c:"003220",m:"KS"},
  {n:"대원화성",c:"024890",m:"KS"},
  {n:"대정화금",c:"120240",m:"KQ"},
  {n:"대주산업",c:"003310",m:"KQ"},
  {n:"대주전자재료",c:"078600",m:"KQ"},
  {n:"대진첨단소재",c:"393970",m:"KQ"},
  {n:"대창",c:"012800",m:"KS"},
  {n:"대창단조",c:"015230",m:"KS"},
  {n:"대창솔루션",c:"096350",m:"KQ"},
  {n:"대창스틸",c:"140520",m:"KQ"},
  {n:"대한과학",c:"131220",m:"KQ"},
  {n:"대한광통신",c:"010170",m:"KQ"},
  {n:"대한뉴팜",c:"054670",m:"KQ"},
  {n:"대한방직",c:"001070",m:"KS"},
  {n:"대한약품",c:"023910",m:"KQ"},
  {n:"대한유화",c:"006650",m:"KS"},
  {n:"대한전선",c:"001440",m:"KS"},
  {n:"대한제강",c:"084010",m:"KS"},
  {n:"대한제당",c:"001790",m:"KS"},
  {n:"대한제당우",c:"001795",m:"KS"},
  {n:"대한제분",c:"001130",m:"KS"},
  {n:"대한조선",c:"439260",m:"KS"},
  {n:"대한항공",c:"003490",m:"KS"},
  {n:"대한항공우",c:"003495",m:"KS"},
  {n:"대한해운",c:"005880",m:"KS"},
  {n:"대한화섬",c:"003830",m:"KS"},
  {n:"대현",c:"016090",m:"KS"},
  {n:"대호에이엘",c:"069460",m:"KS"},
  {n:"대호특수강",c:"021040",m:"KQ"},
  {n:"대호특수강우",c:"021045",m:"KQ"},
  {n:"대화제약",c:"067080",m:"KQ"},
  {n:"더네이쳐홀딩스",c:"298540",m:"KQ"},
  {n:"더라미",c:"032860",m:"KQ"},
  {n:"더본코리아",c:"475560",m:"KS"},
  {n:"더블유게임즈",c:"192080",m:"KS"},
  {n:"더블유씨피",c:"393890",m:"KQ"},
  {n:"더블유에스아이",c:"299170",m:"KQ"},
  {n:"더즌",c:"462860",m:"KQ"},
  {n:"더코디",c:"224060",m:"KQ"},
  {n:"더핑크퐁컴퍼니",c:"403850",m:"KQ"},
  {n:"덕산네오룩스",c:"213420",m:"KQ"},
  {n:"덕산테코피아",c:"317330",m:"KQ"},
  {n:"덕산하이메탈",c:"077360",m:"KQ"},
  {n:"덕성",c:"004830",m:"KS"},
  {n:"덕성우",c:"004835",m:"KS"},
  {n:"덕신이피씨",c:"090410",m:"KQ"},
  {n:"덕양에너젠",c:"0001A0",m:"KQ"},
  {n:"덕우전자",c:"263600",m:"KQ"},
  {n:"데브시스터즈",c:"194480",m:"KQ"},
  {n:"데이원컴퍼니",c:"373160",m:"KQ"},
  {n:"데이타솔루션",c:"263800",m:"KQ"},
  {n:"덱스터",c:"206560",m:"KQ"},
  {n:"덴티스",c:"261200",m:"KQ"},
  {n:"덴티움",c:"145720",m:"KS"},
  {n:"도우인시스",c:"484120",m:"KQ"},
  {n:"도이치모터스",c:"067990",m:"KQ"},
  {n:"도화엔지니어링",c:"002150",m:"KS"},
  {n:"동구바이오제약",c:"006620",m:"KQ"},
  {n:"동국S&C",c:"100130",m:"KQ"},
  {n:"동국산업",c:"005160",m:"KQ"},
  {n:"동국생명과학",c:"303810",m:"KQ"},
  {n:"동국씨엠",c:"460850",m:"KS"},
  {n:"동국알앤에스",c:"075970",m:"KQ"},
  {n:"동국제강",c:"460860",m:"KS"},
  {n:"동국제약",c:"086450",m:"KQ"},
  {n:"동국홀딩스",c:"001230",m:"KS"},
  {n:"동남합성",c:"023450",m:"KS"},
  {n:"동방",c:"004140",m:"KS"},
  {n:"동방메디컬",c:"240550",m:"KQ"},
  {n:"동방선기",c:"099410",m:"KQ"},
  {n:"동방아그로",c:"007590",m:"KS"},
  {n:"동부건설",c:"005960",m:"KS"},
  {n:"동부건설우",c:"005965",m:"KS"},
  {n:"동서",c:"026960",m:"KS"},
  {n:"동성제약",c:"002210",m:"KS"},
  {n:"동성케미컬",c:"102260",m:"KS"},
  {n:"동성화인텍",c:"033500",m:"KQ"},
  {n:"동신건설",c:"025950",m:"KQ"},
  {n:"동아쏘시오홀딩스",c:"000640",m:"KS"},
  {n:"동아에스티",c:"170900",m:"KS"},
  {n:"동아엘텍",c:"088130",m:"KQ"},
  {n:"동아지질",c:"028100",m:"KS"},
  {n:"동양",c:"001520",m:"KS"},
  {n:"동양2우B",c:"001527",m:"KS"},
  {n:"동양고속",c:"084670",m:"KS"},
  {n:"동양생명",c:"082640",m:"KS"},
  {n:"동양에스텍",c:"060380",m:"KQ"},
  {n:"동양우",c:"001525",m:"KS"},
  {n:"동양이엔피",c:"079960",m:"KQ"},
  {n:"동양파일",c:"228340",m:"KQ"},
  {n:"동우팜투테이블",c:"088910",m:"KQ"},
  {n:"동운아나텍",c:"094170",m:"KQ"},
  {n:"동원개발",c:"013120",m:"KQ"},
  {n:"동원모빌리티",c:"018500",m:"KS"},
  {n:"동원산업",c:"006040",m:"KS"},
  {n:"동원수산",c:"030720",m:"KS"},
  {n:"동원시스템즈",c:"014820",m:"KS"},
  {n:"동원시스템즈우",c:"014825",m:"KS"},
  {n:"동인기연",c:"111380",m:"KS"},
  {n:"동일고무벨트",c:"163560",m:"KS"},
  {n:"동일금속",c:"109860",m:"KQ"},
  {n:"동일기연",c:"032960",m:"KQ"},
  {n:"동일산업",c:"004890",m:"KS"},
  {n:"동일스틸럭스",c:"023790",m:"KQ"},
  {n:"동일제강",c:"002690",m:"KS"},
  {n:"동진쎄미켐",c:"005290",m:"KQ"},
  {n:"동화기업",c:"025900",m:"KQ"},
  {n:"동화약품",c:"000020",m:"KS"},
  {n:"두산",c:"000150",m:"KS"},
  {n:"두산2우B",c:"000157",m:"KS"},
  {n:"두산로보틱스",c:"454910",m:"KS"},
  {n:"두산밥캣",c:"241560",m:"KS"},
  {n:"두산에너빌리티",c:"034020",m:"KS"},
  {n:"두산우",c:"000155",m:"KS"},
  {n:"두산테스나",c:"131970",m:"KQ"},
  {n:"두산퓨얼셀",c:"336260",m:"KS"},
  {n:"두산퓨얼셀1우",c:"33626K",m:"KS"},
  {n:"두산퓨얼셀2우B",c:"33626L",m:"KS"},
  {n:"두올",c:"016740",m:"KS"},
  {n:"듀오백",c:"073190",m:"KQ"},
  {n:"듀켐바이오",c:"176750",m:"KQ"},
  {n:"드래곤플라이",c:"030350",m:"KQ"},
  {n:"드림시큐리티",c:"203650",m:"KQ"},
  {n:"드림씨아이에스",c:"223250",m:"KQ"},
  {n:"드림어스컴퍼니",c:"060570",m:"KQ"},
  {n:"드림인사이트",c:"362990",m:"KQ"},
  {n:"드림텍",c:"192650",m:"KS"},
  {n:"디모아",c:"016670",m:"KQ"},
  {n:"디바이스",c:"187870",m:"KQ"},
  {n:"디비금융제13호스팩",c:"489730",m:"KQ"},
  {n:"디비금융제14호스팩",c:"0004Y0",m:"KQ"},
  {n:"디씨엠",c:"024090",m:"KS"},
  {n:"디아이",c:"003160",m:"KS"},
  {n:"디아이씨",c:"092200",m:"KS"},
  {n:"디아이티",c:"110990",m:"KQ"},
  {n:"디알젬",c:"263690",m:"KQ"},
  {n:"디알텍",c:"214680",m:"KQ"},
  {n:"디앤디파마텍",c:"347850",m:"KQ"},
  {n:"디앤디플랫폼리츠",c:"377190",m:"KS"},
  {n:"디앤씨미디어",c:"263720",m:"KQ"},
  {n:"디어유",c:"376300",m:"KQ"},
  {n:"디에스엠",c:"104040",m:"KQ"},
  {n:"디에스케이",c:"109740",m:"KQ"},
  {n:"디에이치엑스컴퍼니",c:"031860",m:"KQ"},
  {n:"디에이테크놀로지",c:"196490",m:"KQ"},
  {n:"디에이피",c:"066900",m:"KQ"},
  {n:"디엔에프",c:"092070",m:"KQ"},
  {n:"디오",c:"039840",m:"KQ"},
  {n:"디와이",c:"013570",m:"KS"},
  {n:"디와이덕양",c:"024900",m:"KS"},
  {n:"디와이디",c:"219550",m:"KQ"},
  {n:"디와이씨",c:"310870",m:"KQ"},
  {n:"디와이에이",c:"002880",m:"KS"},
  {n:"디와이파워",c:"210540",m:"KS"},
  {n:"디와이피엔에프",c:"104460",m:"KQ"},
  {n:"디젠스",c:"113810",m:"KQ"},
  {n:"디지아이",c:"043360",m:"KQ"},
  {n:"디지캡",c:"197140",m:"KQ"},
  {n:"디지털대성",c:"068930",m:"KQ"},
  {n:"디지틀조선",c:"033130",m:"KQ"},
  {n:"디케이락",c:"105740",m:"KQ"},
  {n:"디케이앤디",c:"263020",m:"KQ"},
  {n:"디케이티",c:"290550",m:"KQ"},
  {n:"디티씨",c:"066670",m:"KQ"},
  {n:"디티앤씨",c:"187220",m:"KQ"},
  {n:"디티앤씨알오",c:"383930",m:"KQ"},
  {n:"딜리",c:"131180",m:"KQ"},
  {n:"딜리셔스",c:"483350",m:"KQ"},
  {n:"딥노이드",c:"315640",m:"KQ"},
  {n:"딥커머스",c:"900110",m:"KQ"},
  {n:"라닉스",c:"317120",m:"KQ"},
  {n:"라메디텍",c:"462510",m:"KQ"},
  {n:"라온로보틱스",c:"232680",m:"KQ"},
  {n:"라온시큐어",c:"042510",m:"KQ"},
  {n:"라온텍",c:"418420",m:"KQ"},
  {n:"라온피플",c:"300120",m:"KQ"},
  {n:"라이온켐텍",c:"171120",m:"KQ"},
  {n:"라이콤",c:"388790",m:"KQ"},
  {n:"라파스",c:"214260",m:"KQ"},
  {n:"램테크놀러지",c:"171010",m:"KQ"},
  {n:"랩지노믹스",c:"084650",m:"KQ"},
  {n:"러셀",c:"217500",m:"KQ"},
  {n:"레드캡투어",c:"038390",m:"KQ"},
  {n:"레메디",c:"387690",m:"KQ"},
  {n:"레몬",c:"294140",m:"KQ"},
  {n:"레몬헬스케어",c:"365660",m:"KQ"},
  {n:"레뷰코퍼레이션",c:"443250",m:"KQ"},
  {n:"레이",c:"228670",m:"KQ"},
  {n:"레이언스",c:"228850",m:"KQ"},
  {n:"레이저쎌",c:"412350",m:"KQ"},
  {n:"레이저옵텍",c:"199550",m:"KQ"},
  {n:"레이크머티리얼즈",c:"281740",m:"KQ"},
  {n:"레인보우로보틱스",c:"277810",m:"KQ"},
  {n:"로보로보",c:"215100",m:"KQ"},
  {n:"로보스타",c:"090360",m:"KQ"},
  {n:"로보티즈",c:"108490",m:"KQ"},
  {n:"로스웰",c:"900260",m:"KQ"},
  {n:"로젠",c:"033290",m:"KQ"},
  {n:"로지시스",c:"067730",m:"KQ"},
  {n:"로체시스템즈",c:"071280",m:"KQ"},
  {n:"로킷헬스케어",c:"376900",m:"KQ"},
  {n:"롤링스톤",c:"214610",m:"KQ"},
  {n:"롯데관광개발",c:"032350",m:"KS"},
  {n:"롯데렌탈",c:"089860",m:"KS"},
  {n:"롯데리츠",c:"330590",m:"KS"},
  {n:"롯데손해보험",c:"000400",m:"KS"},
  {n:"롯데쇼핑",c:"023530",m:"KS"},
  {n:"롯데에너지머티리얼즈",c:"020150",m:"KS"},
  {n:"롯데웰푸드",c:"280360",m:"KS"},
  {n:"롯데이노베이트",c:"286940",m:"KS"},
  {n:"롯데정밀화학",c:"004000",m:"KS"},
  {n:"롯데지주",c:"004990",m:"KS"},
  {n:"롯데지주우",c:"00499K",m:"KS"},
  {n:"롯데칠성",c:"005300",m:"KS"},
  {n:"롯데칠성우",c:"005305",m:"KS"},
  {n:"롯데케미칼",c:"011170",m:"KS"},
  {n:"롯데하이마트",c:"071840",m:"KS"},
  {n:"루닛",c:"328130",m:"KQ"},
  {n:"루멘스",c:"038060",m:"KQ"},
  {n:"루미르",c:"474170",m:"KQ"},
  {n:"루트K",c:"195990",m:"KQ"},
  {n:"리가켐바이오",c:"141080",m:"KQ"},
  {n:"리노공업",c:"058470",m:"KQ"},
  {n:"리더스코스메틱",c:"016100",m:"KQ"},
  {n:"리드코프",c:"012700",m:"KQ"},
  {n:"리메드",c:"302550",m:"KQ"},
  {n:"리브스메드",c:"491000",m:"KQ"},
  {n:"리센스메디컬",c:"394420",m:"KQ"},
  {n:"리튬포어스",c:"073570",m:"KQ"},
  {n:"리파인",c:"377450",m:"KQ"},
  {n:"린드먼아시아",c:"277070",m:"KQ"},
  {n:"링네트",c:"042500",m:"KQ"},
  {n:"링크드",c:"193250",m:"KQ"},
  {n:"링크솔루션",c:"474650",m:"KQ"},
  {n:"링크제니시스",c:"219420",m:"KQ"},
  {n:"마녀공장",c:"439090",m:"KQ"},
  {n:"마니커",c:"027740",m:"KS"},
  {n:"마니커에프앤지",c:"195500",m:"KQ"},
  {n:"마스턴프리미어리츠",c:"357430",m:"KS"},
  {n:"마음AI",c:"377480",m:"KQ"},
  {n:"마이크로디지탈",c:"305090",m:"KQ"},
  {n:"마이크로컨텍솔",c:"098120",m:"KQ"},
  {n:"마이크로투나노",c:"424980",m:"KQ"},
  {n:"마크로젠",c:"038290",m:"KQ"},
  {n:"마키나락스",c:"477850",m:"KQ"},
  {n:"만호제강",c:"001080",m:"KS"},
  {n:"매드업",c:"0039P0",m:"KQ"},
  {n:"매일유업",c:"267980",m:"KQ"},
  {n:"매일홀딩스",c:"005990",m:"KQ"},
  {n:"매커스",c:"093520",m:"KQ"},
  {n:"맥쿼리인프라",c:"088980",m:"KS"},
  {n:"맵스리얼티",c:"094800",m:"KS"},
  {n:"머큐리",c:"100590",m:"KQ"},
  {n:"멀티캠퍼스",c:"067280",m:"KQ"},
  {n:"메가스터디",c:"072870",m:"KQ"},
  {n:"메가스터디교육",c:"215200",m:"KQ"},
  {n:"메가엠디",c:"133750",m:"KQ"},
  {n:"메가터치",c:"446540",m:"KQ"},
  {n:"메드팩토",c:"235980",m:"KQ"},
  {n:"메디아나",c:"041920",m:"KQ"},
  {n:"메디앙스",c:"014100",m:"KQ"},
  {n:"메디콕스",c:"054180",m:"KQ"},
  {n:"메디톡스",c:"086900",m:"KQ"},
  {n:"메디포스트",c:"078160",m:"KQ"},
  {n:"메리츠금융지주",c:"138040",m:"KS"},
  {n:"메리츠제1호스팩",c:"0088D0",m:"KQ"},
  {n:"메리츠제2호스팩",c:"0165X0",m:"KQ"},
  {n:"메쎄이상",c:"408920",m:"KQ"},
  {n:"메이슨캐피탈",c:"021880",m:"KQ"},
  {n:"메쥬",c:"0088M0",m:"KQ"},
  {n:"메지온",c:"140410",m:"KQ"},
  {n:"메카로",c:"241770",m:"KQ"},
  {n:"메타랩스",c:"090370",m:"KS"},
  {n:"메타바이오메드",c:"059210",m:"KQ"},
  {n:"메타케어",c:"118000",m:"KS"},
  {n:"멕아이씨에스",c:"058110",m:"KQ"},
  {n:"멤레이비티",c:"072770",m:"KQ"},
  {n:"명문제약",c:"017180",m:"KS"},
  {n:"명신산업",c:"009900",m:"KS"},
  {n:"명인제약",c:"317450",m:"KS"},
  {n:"모나리자",c:"012690",m:"KS"},
  {n:"모나미",c:"005360",m:"KS"},
  {n:"모나용평",c:"070960",m:"KS"},
  {n:"모니터랩",c:"434480",m:"KQ"},
  {n:"모다이노칩",c:"080420",m:"KQ"},
  {n:"모델솔루션",c:"417970",m:"KQ"},
  {n:"모두투어",c:"080160",m:"KQ"},
  {n:"모바일어플라이언스",c:"087260",m:"KQ"},
  {n:"모베이스",c:"101330",m:"KQ"},
  {n:"모베이스전자",c:"012860",m:"KQ"},
  {n:"모비데이즈",c:"363260",m:"KQ"},
  {n:"모비릭스",c:"348030",m:"KQ"},
  {n:"모비스",c:"250060",m:"KQ"},
  {n:"모아데이타",c:"288980",m:"KQ"},
  {n:"모아라이프플러스",c:"142760",m:"KQ"},
  {n:"모아텍",c:"033200",m:"KQ"},
  {n:"모토닉",c:"009680",m:"KS"},
  {n:"모트렉스",c:"118990",m:"KQ"},
  {n:"모티브링크",c:"463480",m:"KQ"},
  {n:"모헨즈",c:"006920",m:"KQ"},
  {n:"무림P&P",c:"009580",m:"KS"},
  {n:"무림SP",c:"001810",m:"KQ"},
  {n:"무림페이퍼",c:"009200",m:"KS"},
  {n:"무학",c:"033920",m:"KS"},
  {n:"문배철강",c:"008420",m:"KS"},
  {n:"미디어젠",c:"279600",m:"KQ"},
  {n:"미래나노텍",c:"095500",m:"KQ"},
  {n:"미래반도체",c:"254490",m:"KQ"},
  {n:"미래산업",c:"025560",m:"KS"},
  {n:"미래생명자원",c:"218150",m:"KQ"},
  {n:"미래아이앤지",c:"007120",m:"KS"},
  {n:"미래에셋글로벌리츠",c:"396690",m:"KS"},
  {n:"미래에셋맵스리츠",c:"357250",m:"KS"},
  {n:"미래에셋벤처투자",c:"100790",m:"KQ"},
  {n:"미래에셋비전스팩10호",c:"0097F0",m:"KQ"},
  {n:"미래에셋비전스팩11호",c:"0099W0",m:"KQ"},
  {n:"미래에셋비전스팩4호",c:"477380",m:"KQ"},
  {n:"미래에셋비전스팩5호",c:"477470",m:"KQ"},
  {n:"미래에셋비전스팩6호",c:"478440",m:"KQ"},
  {n:"미래에셋비전스팩7호",c:"482680",m:"KQ"},
  {n:"미래에셋비전스팩8호",c:"0093G0",m:"KQ"},
  {n:"미래에셋비전스팩9호",c:"0096D0",m:"KQ"},
  {n:"미래에셋생명",c:"085620",m:"KS"},
  {n:"미래에셋증권",c:"006800",m:"KS"},
  {n:"미래에셋증권2우B",c:"00680K",m:"KS"},
  {n:"미래에셋증권우",c:"006805",m:"KS"},
  {n:"미래컴퍼니",c:"049950",m:"KQ"},
  {n:"미스터블루",c:"207760",m:"KQ"},
  {n:"미스토홀딩스",c:"081660",m:"KS"},
  {n:"미원상사",c:"002840",m:"KS"},
  {n:"미원에스씨",c:"268280",m:"KS"},
  {n:"미원홀딩스",c:"107590",m:"KS"},
  {n:"미원화학",c:"134380",m:"KS"},
  {n:"미창석유",c:"003650",m:"KS"},
  {n:"미코",c:"059090",m:"KQ"},
  {n:"미투온",c:"201490",m:"KQ"},
  {n:"미트박스",c:"475460",m:"KQ"},
  {n:"민테크",c:"452200",m:"KQ"},
  {n:"바디텍메드",c:"206640",m:"KQ"},
  {n:"바른손이앤에이",c:"035620",m:"KQ"},
  {n:"바이넥스",c:"053030",m:"KQ"},
  {n:"바이브컴퍼니",c:"301300",m:"KQ"},
  {n:"바이오노트",c:"377740",m:"KS"},
  {n:"바이오니아",c:"064550",m:"KQ"},
  {n:"바이오다인",c:"314930",m:"KQ"},
  {n:"바이오비쥬",c:"489460",m:"KQ"},
  {n:"바이오솔루션",c:"086820",m:"KQ"},
  {n:"바이오스마트",c:"038460",m:"KQ"},
  {n:"바이오에프디엔씨",c:"251120",m:"KQ"},
  {n:"바이오인프라",c:"199730",m:"KQ"},
  {n:"바이오톡스텍",c:"086040",m:"KQ"},
  {n:"바이오포트",c:"188040",m:"KQ"},
  {n:"바이오플러스",c:"099430",m:"KQ"},
  {n:"바이젠셀",c:"308080",m:"KQ"},
  {n:"바텍",c:"043150",m:"KQ"},
  {n:"박셀바이오",c:"323990",m:"KQ"},
  {n:"방림",c:"003610",m:"KS"},
  {n:"배럴",c:"267790",m:"KQ"},
  {n:"백금T&A",c:"046310",m:"KQ"},
  {n:"백산",c:"035150",m:"KS"},
  {n:"밸로프",c:"331520",m:"KQ"},
  {n:"뱅크웨어글로벌",c:"199480",m:"KQ"},
  {n:"버넥트",c:"438700",m:"KQ"},
  {n:"버킷스튜디오",c:"066410",m:"KQ"},
  {n:"범양건영",c:"002410",m:"KS"},
  {n:"범한퓨얼셀",c:"382900",m:"KQ"},
  {n:"베노티앤알",c:"206400",m:"KQ"},
  {n:"베뉴지",c:"019010",m:"KQ"},
  {n:"베셀",c:"177350",m:"KQ"},
  {n:"벡트",c:"457600",m:"KQ"},
  {n:"벨로크",c:"424760",m:"KQ"},
  {n:"벽산",c:"007210",m:"KS"},
  {n:"보라티알",c:"250000",m:"KQ"},
  {n:"보락",c:"002760",m:"KS"},
  {n:"보령",c:"003850",m:"KS"},
  {n:"보로노이",c:"310210",m:"KQ"},
  {n:"보성파워텍",c:"006910",m:"KQ"},
  {n:"보원케미칼",c:"0010F0",m:"KQ"},
  {n:"보해양조",c:"000890",m:"KS"},
  {n:"본느",c:"226340",m:"KQ"},
  {n:"부광약품",c:"003000",m:"KS"},
  {n:"부국증권",c:"001270",m:"KS"},
  {n:"부국증권우",c:"001275",m:"KS"},
  {n:"부국철강",c:"026940",m:"KS"},
  {n:"부방",c:"014470",m:"KQ"},
  {n:"부산산업",c:"011390",m:"KS"},
  {n:"부산주공",c:"005030",m:"KS"},
  {n:"부스타",c:"008470",m:"KQ"},
  {n:"뷰노",c:"338220",m:"KQ"},
  {n:"뷰웍스",c:"100120",m:"KQ"},
  {n:"뷰티스킨",c:"406820",m:"KQ"},
  {n:"브레인즈컴퍼니",c:"099390",m:"KQ"},
  {n:"브리지텍",c:"064480",m:"KQ"},
  {n:"브이씨",c:"365900",m:"KQ"},
  {n:"브이엠",c:"089970",m:"KQ"},
  {n:"브이원텍",c:"251630",m:"KQ"},
  {n:"브이티",c:"018290",m:"KQ"},
  {n:"블랙야크아이앤씨",c:"478560",m:"KQ"},
  {n:"블루산업개발",c:"006740",m:"KS"},
  {n:"블루엠텍",c:"439580",m:"KQ"},
  {n:"블루콤",c:"033560",m:"KQ"},
  {n:"블리츠웨이엔터테인먼트",c:"369370",m:"KQ"},
  {n:"비나텍",c:"126340",m:"KQ"},
  {n:"비덴트",c:"121800",m:"KQ"},
  {n:"비보존 제약",c:"082800",m:"KQ"},
  {n:"비비씨",c:"318410",m:"KQ"},
  {n:"비비안",c:"002070",m:"KS"},
  {n:"비상교육",c:"100220",m:"KS"},
  {n:"비스토스",c:"419540",m:"KQ"},
  {n:"비씨엔씨",c:"146320",m:"KQ"},
  {n:"비씨월드제약",c:"200780",m:"KQ"},
  {n:"비아이매트릭스",c:"413640",m:"KQ"},
  {n:"비아트론",c:"141000",m:"KQ"},
  {n:"비에이치",c:"090460",m:"KS"},
  {n:"비에이치아이",c:"083650",m:"KQ"},
  {n:"비엔케이제3호스팩",c:"0068Y0",m:"KQ"},
  {n:"비엘팜텍",c:"065170",m:"KQ"},
  {n:"비엠티",c:"086670",m:"KQ"},
  {n:"비츠로넥스텍",c:"488900",m:"KQ"},
  {n:"비츠로셀",c:"082920",m:"KQ"},
  {n:"비츠로시스",c:"054220",m:"KQ"},
  {n:"비츠로테크",c:"042370",m:"KQ"},
  {n:"비케이홀딩스",c:"050090",m:"KQ"},
  {n:"비큐AI",c:"148780",m:"KQ"},
  {n:"비투엔",c:"307870",m:"KQ"},
  {n:"비트맥스",c:"377030",m:"KQ"},
  {n:"비트컴퓨터",c:"032850",m:"KQ"},
  {n:"비트플래닛",c:"049470",m:"KQ"},
  {n:"비피도",c:"238200",m:"KQ"},
  {n:"빅솔론",c:"093190",m:"KQ"},
  {n:"빅텍",c:"065450",m:"KQ"},
  {n:"빌리언스",c:"044480",m:"KQ"},
  {n:"빙그레",c:"005180",m:"KS"},
  {n:"빛과전자",c:"069540",m:"KQ"},
  {n:"빛샘전자",c:"072950",m:"KQ"},
  {n:"삐아",c:"451250",m:"KQ"},
  {n:"사람인",c:"143240",m:"KQ"},
  {n:"사이냅소프트",c:"466410",m:"KQ"},
  {n:"사조대림",c:"003960",m:"KS"},
  {n:"사조동아원",c:"008040",m:"KS"},
  {n:"사조산업",c:"007160",m:"KS"},
  {n:"사조씨푸드",c:"014710",m:"KS"},
  {n:"사조오양",c:"006090",m:"KS"},
  {n:"사토시홀딩스",c:"223310",m:"KQ"},
  {n:"사피엔반도체",c:"452430",m:"KQ"},
  {n:"산돌",c:"419120",m:"KQ"},
  {n:"산일전기",c:"062040",m:"KS"},
  {n:"삼기",c:"122350",m:"KQ"},
  {n:"삼기에너지솔루션즈",c:"419050",m:"KQ"},
  {n:"삼륭물산",c:"014970",m:"KQ"},
  {n:"삼립",c:"005610",m:"KS"},
  {n:"삼목에스폼",c:"018310",m:"KQ"},
  {n:"삼미금속",c:"012210",m:"KQ"},
  {n:"삼보모터스",c:"053700",m:"KQ"},
  {n:"삼보산업",c:"009620",m:"KQ"},
  {n:"삼보판지",c:"023600",m:"KQ"},
  {n:"삼부토건",c:"001470",m:"KS"},
  {n:"삼성E&A",c:"028050",m:"KS"},
  {n:"삼성FN리츠",c:"448730",m:"KS"},
  {n:"삼성SDI",c:"006400",m:"KS"},
  {n:"삼성SDI우",c:"006405",m:"KS"},
  {n:"삼성공조",c:"006660",m:"KS"},
  {n:"삼성물산",c:"028260",m:"KS"},
  {n:"삼성물산우B",c:"02826K",m:"KS"},
  {n:"삼성바이오로직스",c:"207940",m:"KS"},
  {n:"삼성생명",c:"032830",m:"KS"},
  {n:"삼성스팩10호",c:"0044K0",m:"KQ"},
  {n:"삼성스팩11호",c:"0071M0",m:"KQ"},
  {n:"삼성스팩12호",c:"0096B0",m:"KQ"},
  {n:"삼성스팩13호",c:"0115H0",m:"KQ"},
  {n:"삼성에스디에스",c:"018260",m:"KS"},
  {n:"삼성에피스홀딩스",c:"0126Z0",m:"KS"},
  {n:"삼성전기",c:"009150",m:"KS"},
  {n:"삼성전기우",c:"009155",m:"KS"},
  {n:"삼성전자",c:"005930",m:"KS"},
  {n:"삼성전자우",c:"005935",m:"KS"},
  {n:"삼성제약",c:"001360",m:"KS"},
  {n:"삼성중공업",c:"010140",m:"KS"},
  {n:"삼성증권",c:"016360",m:"KS"},
  {n:"삼성출판사",c:"068290",m:"KS"},
  {n:"삼성카드",c:"029780",m:"KS"},
  {n:"삼성화재",c:"000810",m:"KS"},
  {n:"삼성화재우",c:"000815",m:"KS"},
  {n:"삼아알미늄",c:"006110",m:"KS"},
  {n:"삼아제약",c:"009300",m:"KQ"},
  {n:"삼양바이오팜",c:"0120G0",m:"KS"},
  {n:"삼양사",c:"145990",m:"KS"},
  {n:"삼양사우",c:"145995",m:"KS"},
  {n:"삼양식품",c:"003230",m:"KS"},
  {n:"삼양엔씨켐",c:"482630",m:"KQ"},
  {n:"삼양컴텍",c:"484590",m:"KQ"},
  {n:"삼양케이씨아이",c:"036670",m:"KQ"},
  {n:"삼양패키징",c:"272550",m:"KS"},
  {n:"삼양홀딩스",c:"000070",m:"KS"},
  {n:"삼영",c:"003720",m:"KS"},
  {n:"삼영무역",c:"002810",m:"KS"},
  {n:"삼영에스앤씨",c:"361670",m:"KQ"},
  {n:"삼영엠텍",c:"054540",m:"KQ"},
  {n:"삼영이엔씨",c:"065570",m:"KQ"},
  {n:"삼영전자",c:"005680",m:"KS"},
  {n:"삼원강재",c:"023000",m:"KS"},
  {n:"삼익THK",c:"004380",m:"KS"},
  {n:"삼익악기",c:"002450",m:"KS"},
  {n:"삼익제약",c:"014950",m:"KQ"},
  {n:"삼일",c:"032280",m:"KQ"},
  {n:"삼일기업공사",c:"002290",m:"KQ"},
  {n:"삼일씨엔에스",c:"004440",m:"KS"},
  {n:"삼일제약",c:"000520",m:"KS"},
  {n:"삼정펄프",c:"009770",m:"KS"},
  {n:"삼지전자",c:"037460",m:"KQ"},
  {n:"삼진",c:"032750",m:"KQ"},
  {n:"삼진식품",c:"0013V0",m:"KQ"},
  {n:"삼진엘앤디",c:"054090",m:"KQ"},
  {n:"삼진제약",c:"005500",m:"KS"},
  {n:"삼천당제약",c:"000250",m:"KQ"},
  {n:"삼천리",c:"004690",m:"KS"},
  {n:"삼천리자전거",c:"024950",m:"KQ"},
  {n:"삼표시멘트",c:"038500",m:"KQ"},
  {n:"삼현",c:"437730",m:"KQ"},
  {n:"삼현철강",c:"017480",m:"KQ"},
  {n:"삼호개발",c:"010960",m:"KS"},
  {n:"삼화네트웍스",c:"046390",m:"KQ"},
  {n:"삼화왕관",c:"004450",m:"KS"},
  {n:"삼화전기",c:"009470",m:"KS"},
  {n:"삼화전자",c:"011230",m:"KS"},
  {n:"삼화콘덴서",c:"001820",m:"KS"},
  {n:"상보",c:"027580",m:"KQ"},
  {n:"상상인",c:"038540",m:"KQ"},
  {n:"상상인증권",c:"001290",m:"KS"},
  {n:"상신브레이크",c:"041650",m:"KS"},
  {n:"상신이디피",c:"091580",m:"KQ"},
  {n:"상신전자",c:"263810",m:"KQ"},
  {n:"상아프론테크",c:"089980",m:"KQ"},
  {n:"상지건설",c:"042940",m:"KQ"},
  {n:"새로닉스",c:"042600",m:"KQ"},
  {n:"새론오토모티브",c:"075180",m:"KS"},
  {n:"새빗켐",c:"107600",m:"KQ"},
  {n:"샌즈랩",c:"411080",m:"KQ"},
  {n:"샘씨엔에스",c:"252990",m:"KQ"},
  {n:"샘표",c:"007540",m:"KS"},
  {n:"샘표식품",c:"248170",m:"KS"},
  {n:"샤페론",c:"378800",m:"KQ"},
  {n:"서남",c:"294630",m:"KQ"},
  {n:"서린바이오",c:"038070",m:"KQ"},
  {n:"서부T&D",c:"006730",m:"KQ"},
  {n:"서산",c:"079650",m:"KQ"},
  {n:"서암기계공업",c:"100660",m:"KQ"},
  {n:"서연",c:"007860",m:"KS"},
  {n:"서연이화",c:"200880",m:"KS"},
  {n:"서연탑메탈",c:"019770",m:"KQ"},
  {n:"서울가스",c:"017390",m:"KS"},
  {n:"서울바이오시스",c:"092190",m:"KQ"},
  {n:"서울반도체",c:"046890",m:"KQ"},
  {n:"서울보증보험",c:"031210",m:"KS"},
  {n:"서울식품",c:"004410",m:"KS"},
  {n:"서울식품우",c:"004415",m:"KS"},
  {n:"서울옥션",c:"063170",m:"KQ"},
  {n:"서울전자통신",c:"027040",m:"KQ"},
  {n:"서울제약",c:"018680",m:"KQ"},
  {n:"서울평가정보",c:"036120",m:"KQ"},
  {n:"서원",c:"021050",m:"KS"},
  {n:"서원인텍",c:"093920",m:"KQ"},
  {n:"서전기전",c:"189860",m:"KQ"},
  {n:"서진시스템",c:"178320",m:"KQ"},
  {n:"서진오토모티브",c:"122690",m:"KQ"},
  {n:"서플러스글로벌",c:"140070",m:"KQ"},
  {n:"서한",c:"011370",m:"KQ"},
  {n:"서호전기",c:"065710",m:"KQ"},
  {n:"서흥",c:"008490",m:"KS"},
  {n:"서희건설",c:"035890",m:"KQ"},
  {n:"석경에이티",c:"357550",m:"KQ"},
  {n:"선광",c:"003100",m:"KQ"},
  {n:"선도전기",c:"007610",m:"KS"},
  {n:"선바이오",c:"067370",m:"KQ"},
  {n:"선익시스템",c:"171090",m:"KQ"},
  {n:"선진",c:"136490",m:"KS"},
  {n:"선진뷰티사이언스",c:"086710",m:"KQ"},
  {n:"성광벤드",c:"014620",m:"KQ"},
  {n:"성도이엔지",c:"037350",m:"KQ"},
  {n:"성문전자",c:"014910",m:"KS"},
  {n:"성문전자우",c:"014915",m:"KS"},
  {n:"성신양회",c:"004980",m:"KS"},
  {n:"성신양회우",c:"004985",m:"KS"},
  {n:"성우",c:"458650",m:"KQ"},
  {n:"성우전자",c:"081580",m:"KQ"},
  {n:"성우테크론",c:"045300",m:"KQ"},
  {n:"성우하이텍",c:"015750",m:"KQ"},
  {n:"성원에너텍",c:"340930",m:"KQ"},
  {n:"성일하이텍",c:"365340",m:"KQ"},
  {n:"성창기업지주",c:"000180",m:"KS"},
  {n:"성창오토텍",c:"080470",m:"KQ"},
  {n:"성호전자",c:"043260",m:"KQ"},
  {n:"세경하이테크",c:"148150",m:"KQ"},
  {n:"세기상사",c:"002420",m:"KS"},
  {n:"세나테크놀로지",c:"061090",m:"KQ"},
  {n:"세니젠",c:"188260",m:"KQ"},
  {n:"세동",c:"053060",m:"KQ"},
  {n:"세림B&G",c:"340440",m:"KQ"},
  {n:"세명전기",c:"017510",m:"KQ"},
  {n:"세미티에스",c:"0017J0",m:"KQ"},
  {n:"세미파이브",c:"490470",m:"KQ"},
  {n:"세방",c:"004360",m:"KS"},
  {n:"세방우",c:"004365",m:"KS"},
  {n:"세방전지",c:"004490",m:"KS"},
  {n:"세보엠이씨",c:"011560",m:"KQ"},
  {n:"세아메카닉스",c:"396300",m:"KQ"},
  {n:"세아베스틸지주",c:"001430",m:"KS"},
  {n:"세아제강",c:"306200",m:"KS"},
  {n:"세아제강지주",c:"003030",m:"KS"},
  {n:"세아홀딩스",c:"058650",m:"KS"},
  {n:"세우글로벌",c:"013000",m:"KS"},
  {n:"세운메디칼",c:"100700",m:"KQ"},
  {n:"세원물산",c:"024830",m:"KQ"},
  {n:"세원정공",c:"021820",m:"KS"},
  {n:"세이브존I&C",c:"067830",m:"KS"},
  {n:"세종메디칼",c:"258830",m:"KQ"},
  {n:"세종텔레콤",c:"036630",m:"KQ"},
  {n:"세중",c:"039310",m:"KQ"},
  {n:"세진중공업",c:"075580",m:"KS"},
  {n:"세진티에스",c:"067770",m:"KQ"},
  {n:"세코닉스",c:"053450",m:"KQ"},
  {n:"세화피앤씨",c:"252500",m:"KQ"},
  {n:"센서뷰",c:"321370",m:"KQ"},
  {n:"센코",c:"347000",m:"KQ"},
  {n:"셀레믹스",c:"331920",m:"KQ"},
  {n:"셀레스트라",c:"352770",m:"KQ"},
  {n:"셀로맥스사이언스",c:"471820",m:"KQ"},
  {n:"셀루메드",c:"049180",m:"KQ"},
  {n:"셀리드",c:"299660",m:"KQ"},
  {n:"셀바스AI",c:"108860",m:"KQ"},
  {n:"셀바스헬스케어",c:"208370",m:"KQ"},
  {n:"셀바이오휴먼텍",c:"318160",m:"KQ"},
  {n:"셀비온",c:"308430",m:"KQ"},
  {n:"셀트리온",c:"068270",m:"KS"},
  {n:"셀트리온제약",c:"068760",m:"KQ"},
  {n:"셀피글로벌",c:"068940",m:"KQ"},
  {n:"소노스퀘어",c:"007720",m:"KQ"},
  {n:"소마젠",c:"950200",m:"KQ"},
  {n:"소프트센",c:"032680",m:"KQ"},
  {n:"소프트센우",c:"032685",m:"KQ"},
  {n:"소프트캠프",c:"258790",m:"KQ"},
  {n:"손오공",c:"066910",m:"KQ"},
  {n:"솔디펜스",c:"215090",m:"KQ"},
  {n:"솔루스첨단소재",c:"336370",m:"KS"},
  {n:"솔루스첨단소재1우",c:"33637K",m:"KS"},
  {n:"솔루스첨단소재2우B",c:"33637L",m:"KS"},
  {n:"솔루엠",c:"248070",m:"KS"},
  {n:"솔본",c:"035610",m:"KQ"},
  {n:"솔브레인",c:"357780",m:"KQ"},
  {n:"솔브레인홀딩스",c:"036830",m:"KQ"},
  {n:"솔트룩스",c:"304100",m:"KQ"},
  {n:"솔트웨어",c:"328380",m:"KQ"},
  {n:"송원산업",c:"004430",m:"KS"},
  {n:"쇼박스",c:"086980",m:"KQ"},
  {n:"수산세보틱스",c:"017550",m:"KS"},
  {n:"수산아이앤티",c:"050960",m:"KQ"},
  {n:"수산인더스트리",c:"126720",m:"KS"},
  {n:"수성웹툰",c:"084180",m:"KQ"},
  {n:"수젠텍",c:"253840",m:"KQ"},
  {n:"슈어소프트테크",c:"298830",m:"KQ"},
  {n:"슈프리마",c:"236200",m:"KQ"},
  {n:"슈프리마에이치큐",c:"094840",m:"KQ"},
  {n:"슈피겐코리아",c:"192440",m:"KQ"},
  {n:"스마트레이더시스템",c:"424960",m:"KQ"},
  {n:"스맥",c:"099440",m:"KQ"},
  {n:"스모트로닉",c:"066590",m:"KQ"},
  {n:"스카이라이프",c:"053210",m:"KS"},
  {n:"스코넥",c:"276040",m:"KQ"},
  {n:"스타플렉스",c:"115570",m:"KQ"},
  {n:"스톤브릿지벤처스",c:"330730",m:"KQ"},
  {n:"스톰테크",c:"352090",m:"KQ"},
  {n:"스튜디오드래곤",c:"253450",m:"KQ"},
  {n:"스튜디오미르",c:"408900",m:"KQ"},
  {n:"스튜디오삼익",c:"415380",m:"KQ"},
  {n:"스트라드비젼",c:"475040",m:"KQ"},
  {n:"스틱인베스트먼트",c:"026890",m:"KS"},
  {n:"스페코",c:"013810",m:"KQ"},
  {n:"스피어",c:"347700",m:"KQ"},
  {n:"승일",c:"049830",m:"KQ"},
  {n:"시공테크",c:"020710",m:"KQ"},
  {n:"시그네틱스",c:"033170",m:"KQ"},
  {n:"시너지이노베이션",c:"048870",m:"KQ"},
  {n:"시노펙스",c:"025320",m:"KQ"},
  {n:"시디즈",c:"134790",m:"KS"},
  {n:"시선AI",c:"340810",m:"KQ"},
  {n:"시스웍",c:"269620",m:"KQ"},
  {n:"시지메드텍",c:"056090",m:"KQ"},
  {n:"시지트로닉스",c:"429270",m:"KQ"},
  {n:"시큐레터",c:"418250",m:"KQ"},
  {n:"시큐브",c:"131090",m:"KQ"},
  {n:"시프트업",c:"462870",m:"KS"},
  {n:"신대양제지",c:"016590",m:"KS"},
  {n:"신도기연",c:"290520",m:"KQ"},
  {n:"신도리코",c:"029530",m:"KS"},
  {n:"신라교역",c:"004970",m:"KS"},
  {n:"신라섬유",c:"001000",m:"KQ"},
  {n:"신라에스지",c:"025870",m:"KQ"},
  {n:"신라젠",c:"215600",m:"KQ"},
  {n:"신성델타테크",c:"065350",m:"KQ"},
  {n:"신성에스티",c:"416180",m:"KQ"},
  {n:"신성이엔지",c:"011930",m:"KS"},
  {n:"신세계",c:"004170",m:"KS"},
  {n:"신세계 I&C",c:"035510",m:"KS"},
  {n:"신세계인터내셔날",c:"031430",m:"KS"},
  {n:"신송홀딩스",c:"006880",m:"KS"},
  {n:"신스틸",c:"162300",m:"KQ"},
  {n:"신신제약",c:"002800",m:"KQ"},
  {n:"신영스팩10호",c:"472220",m:"KQ"},
  {n:"신영스팩11호",c:"0091W0",m:"KQ"},
  {n:"신영와코루",c:"005800",m:"KS"},
  {n:"신영증권",c:"001720",m:"KS"},
  {n:"신원",c:"009270",m:"KS"},
  {n:"신원종합개발",c:"017000",m:"KQ"},
  {n:"신일전자",c:"002700",m:"KS"},
  {n:"신일제약",c:"012790",m:"KQ"},
  {n:"신진에스엠",c:"138070",m:"KQ"},
  {n:"신테카바이오",c:"226330",m:"KQ"},
  {n:"신풍",c:"002870",m:"KS"},
  {n:"신풍제약",c:"019170",m:"KS"},
  {n:"신풍제약우",c:"019175",m:"KS"},
  {n:"신한글로벌액티브리츠",c:"481850",m:"KS"},
  {n:"신한서부티엔디리츠",c:"404990",m:"KS"},
  {n:"신한알파리츠",c:"293940",m:"KS"},
  {n:"신한제12호스팩",c:"474660",m:"KQ"},
  {n:"신한제13호스팩",c:"474930",m:"KQ"},
  {n:"신한제14호스팩",c:"487360",m:"KQ"},
  {n:"신한제15호스팩",c:"487830",m:"KQ"},
  {n:"신한제16호스팩",c:"496070",m:"KQ"},
  {n:"신한제17호스팩",c:"0130D0",m:"KQ"},
  {n:"신한제18호스팩",c:"0129K0",m:"KQ"},
  {n:"신한지주",c:"055550",m:"KS"},
  {n:"신화인터텍",c:"056700",m:"KQ"},
  {n:"신화콘텍",c:"187270",m:"KQ"},
  {n:"신화프리텍",c:"095190",m:"KQ"},
  {n:"신흥",c:"004080",m:"KS"},
  {n:"신흥에스이씨",c:"243840",m:"KQ"},
  {n:"실리콘투",c:"257720",m:"KQ"},
  {n:"심텍",c:"222800",m:"KQ"},
  {n:"심텍홀딩스",c:"036710",m:"KQ"},
  {n:"심플랫폼",c:"444530",m:"KQ"},
  {n:"싸이닉솔루션",c:"234030",m:"KQ"},
  {n:"싸이맥스",c:"160980",m:"KQ"},
  {n:"싸이버원",c:"356890",m:"KQ"},
  {n:"싸이토젠",c:"217330",m:"KQ"},
  {n:"써니전자",c:"004770",m:"KS"},
  {n:"썸에이지",c:"208640",m:"KQ"},
  {n:"쎄노텍",c:"222420",m:"KQ"},
  {n:"쎄니트",c:"037760",m:"KQ"},
  {n:"쎄크",c:"081180",m:"KQ"},
  {n:"쎄트렉아이",c:"099320",m:"KQ"},
  {n:"쎌바이오텍",c:"049960",m:"KQ"},
  {n:"쏘닉스",c:"088280",m:"KQ"},
  {n:"쏘카",c:"403550",m:"KS"},
  {n:"쏠리드",c:"050890",m:"KQ"},
  {n:"쓰리빌리언",c:"394800",m:"KQ"},
  {n:"쓰리에이로직스",c:"177900",m:"KQ"},
  {n:"씨메스로보틱스",c:"475400",m:"KQ"},
  {n:"씨싸이트",c:"109670",m:"KQ"},
  {n:"씨씨에스",c:"066790",m:"KQ"},
  {n:"씨아이테크",c:"004920",m:"KS"},
  {n:"씨앤씨인터내셔널",c:"352480",m:"KQ"},
  {n:"씨앤지하이테크",c:"264660",m:"KQ"},
  {n:"씨앤투스",c:"352700",m:"KQ"},
  {n:"씨어스",c:"458870",m:"KQ"},
  {n:"씨에스베어링",c:"297090",m:"KQ"},
  {n:"씨에스윈드",c:"112610",m:"KS"},
  {n:"씨엑스아이",c:"900120",m:"KQ"},
  {n:"씨엔알리서치",c:"359090",m:"KQ"},
  {n:"씨엔플러스",c:"115530",m:"KQ"},
  {n:"씨엠티엑스",c:"388210",m:"KQ"},
  {n:"씨유메디칼",c:"115480",m:"KQ"},
  {n:"씨유테크",c:"376290",m:"KQ"},
  {n:"씨이랩",c:"189330",m:"KQ"},
  {n:"씨젠",c:"096530",m:"KQ"},
  {n:"씨케이솔루션",c:"480370",m:"KS"},
  {n:"씨큐브",c:"101240",m:"KQ"},
  {n:"씨티씨바이오",c:"060590",m:"KQ"},
  {n:"씨티알모빌리티",c:"308170",m:"KS"},
  {n:"씨티케이",c:"260930",m:"KQ"},
  {n:"씨피시스템",c:"413630",m:"KQ"},
  {n:"아가방컴퍼니",c:"013990",m:"KQ"},
  {n:"아고스",c:"175140",m:"KQ"},
  {n:"아나패스",c:"123860",m:"KQ"},
  {n:"아난티",c:"025980",m:"KQ"},
  {n:"아남전자",c:"008700",m:"KS"},
  {n:"아로마티카",c:"0015N0",m:"KQ"},
  {n:"아리바이오랩",c:"261780",m:"KQ"},
  {n:"아리바이오홀딩스",c:"290690",m:"KQ"},
  {n:"아모그린텍",c:"125210",m:"KQ"},
  {n:"아모레퍼시픽",c:"090430",m:"KS"},
  {n:"아모레퍼시픽우",c:"090435",m:"KS"},
  {n:"아모레퍼시픽홀딩스",c:"002790",m:"KS"},
  {n:"아모레퍼시픽홀딩스3우C",c:"00279K",m:"KS"},
  {n:"아모레퍼시픽홀딩스우",c:"002795",m:"KS"},
  {n:"아모센스",c:"357580",m:"KQ"},
  {n:"아모텍",c:"052710",m:"KQ"},
  {n:"아미노로직스",c:"074430",m:"KQ"},
  {n:"아미코젠",c:"092040",m:"KQ"},
  {n:"아바코",c:"083930",m:"KQ"},
  {n:"아바텍",c:"149950",m:"KQ"},
  {n:"아비코전자",c:"036010",m:"KQ"},
  {n:"아세아",c:"002030",m:"KS"},
  {n:"아세아시멘트",c:"183190",m:"KS"},
  {n:"아세아제지",c:"002310",m:"KS"},
  {n:"아세아텍",c:"050860",m:"KQ"},
  {n:"아센디오",c:"012170",m:"KS"},
  {n:"아셈스",c:"136410",m:"KQ"},
  {n:"아스타",c:"246720",m:"KQ"},
  {n:"아스테라시스",c:"450950",m:"KQ"},
  {n:"아스트",c:"067390",m:"KQ"},
  {n:"아스플로",c:"159010",m:"KQ"},
  {n:"아시아경제",c:"127710",m:"KQ"},
  {n:"아시아나IDT",c:"267850",m:"KS"},
  {n:"아시아나항공",c:"020560",m:"KS"},
  {n:"아시아종묘",c:"154030",m:"KQ"},
  {n:"아우딘퓨쳐스",c:"227610",m:"KQ"},
  {n:"아우토크립트",c:"331740",m:"KQ"},
  {n:"아이디스",c:"143160",m:"KQ"},
  {n:"아이디스홀딩스",c:"054800",m:"KQ"},
  {n:"아이디피",c:"332370",m:"KQ"},
  {n:"아이로보틱스",c:"066430",m:"KQ"},
  {n:"아이마켓코리아",c:"122900",m:"KS"},
  {n:"아이비김영",c:"339950",m:"KQ"},
  {n:"아이비젼웍스",c:"469750",m:"KQ"},
  {n:"아이빔테크놀로지",c:"460470",m:"KQ"},
  {n:"아이센스",c:"099190",m:"KQ"},
  {n:"아이스크림미디어",c:"461300",m:"KQ"},
  {n:"아이스크림에듀",c:"289010",m:"KQ"},
  {n:"아이쓰리시스템",c:"214430",m:"KQ"},
  {n:"아이씨디",c:"040910",m:"KQ"},
  {n:"아이씨에이치",c:"368600",m:"KQ"},
  {n:"아이씨티케이",c:"456010",m:"KQ"},
  {n:"아이앤씨",c:"052860",m:"KQ"},
  {n:"아이언디바이스",c:"464500",m:"KQ"},
  {n:"아이에스동서",c:"010780",m:"KS"},
  {n:"아이에스티이",c:"212710",m:"KQ"},
  {n:"아이에이",c:"038880",m:"KQ"},
  {n:"아이엘",c:"307180",m:"KQ"},
  {n:"아이엠바이오로직스",c:"493280",m:"KQ"},
  {n:"아이엠비디엑스",c:"461030",m:"KQ"},
  {n:"아이엠티",c:"451220",m:"KQ"},
  {n:"아이오케이이엔엠",c:"078860",m:"KQ"},
  {n:"아이윈",c:"090150",m:"KQ"},
  {n:"아이즈비전",c:"031310",m:"KQ"},
  {n:"아이지넷",c:"462980",m:"KQ"},
  {n:"아이진",c:"185490",m:"KQ"},
  {n:"아이컴포넌트",c:"059100",m:"KQ"},
  {n:"아이퀘스트",c:"262840",m:"KQ"},
  {n:"아이큐어",c:"175250",m:"KQ"},
  {n:"아이크래프트",c:"052460",m:"KQ"},
  {n:"아이텍",c:"119830",m:"KQ"},
  {n:"아이톡시",c:"052770",m:"KQ"},
  {n:"아이티센글로벌",c:"124500",m:"KQ"},
  {n:"아이티센씨티에스",c:"031820",m:"KS"},
  {n:"아이티센엔텍",c:"010280",m:"KQ"},
  {n:"아이티센피엔에스",c:"232830",m:"KQ"},
  {n:"아이티아이즈",c:"372800",m:"KQ"},
  {n:"아이티엠반도체",c:"084850",m:"KQ"},
  {n:"아이티켐",c:"309710",m:"KQ"},
  {n:"아이패밀리에스씨",c:"114840",m:"KQ"},
  {n:"아주IB투자",c:"027360",m:"KQ"},
  {n:"아주스틸",c:"139990",m:"KS"},
  {n:"아즈텍WB",c:"032080",m:"KQ"},
  {n:"아진산업",c:"013310",m:"KQ"},
  {n:"아진엑스텍",c:"059120",m:"KQ"},
  {n:"아진전자부품",c:"009320",m:"KS"},
  {n:"아크릴",c:"0007C0",m:"KQ"},
  {n:"아톤",c:"158430",m:"KQ"},
  {n:"아틀라스링크",c:"297570",m:"KQ"},
  {n:"아티스트스튜디오",c:"200350",m:"KQ"},
  {n:"아티스트컴퍼니",c:"321820",m:"KQ"},
  {n:"안국약품",c:"001540",m:"KQ"},
  {n:"안랩",c:"053800",m:"KQ"},
  {n:"안트로젠",c:"065660",m:"KQ"},
  {n:"알루코",c:"001780",m:"KS"},
  {n:"알리코제약",c:"260660",m:"KQ"},
  {n:"알멕",c:"354320",m:"KQ"},
  {n:"알비더블유",c:"361570",m:"KQ"},
  {n:"알서포트",c:"131370",m:"KQ"},
  {n:"알에스오토메이션",c:"140670",m:"KQ"},
  {n:"알에프세미",c:"096610",m:"KQ"},
  {n:"알에프텍",c:"061040",m:"KQ"},
  {n:"알엔투테크놀로지",c:"148250",m:"KQ"},
  {n:"알엔티엑스",c:"123010",m:"KQ"},
  {n:"알지노믹스",c:"476830",m:"KQ"},
  {n:"알체라",c:"347860",m:"KQ"},
  {n:"알테오젠",c:"196170",m:"KQ"},
  {n:"알톤",c:"123750",m:"KQ"},
  {n:"알트",c:"459550",m:"KQ"},
  {n:"알티캐스트",c:"085810",m:"KQ"},
  {n:"알파AI",c:"043100",m:"KQ"},
  {n:"알파칩스",c:"117670",m:"KQ"},
  {n:"알피바이오",c:"314140",m:"KQ"},
  {n:"압타바이오",c:"293780",m:"KQ"},
  {n:"애경산업",c:"018250",m:"KS"},
  {n:"애경케미칼",c:"161000",m:"KS"},
  {n:"애니플러스",c:"310200",m:"KQ"},
  {n:"애드바이오텍",c:"179530",m:"KQ"},
  {n:"애드포러스",c:"397810",m:"KQ"},
  {n:"액스비스",c:"0011A0",m:"KQ"},
  {n:"액토즈소프트",c:"052790",m:"KQ"},
  {n:"액트로",c:"290740",m:"KQ"},
  {n:"앤디포스",c:"238090",m:"KQ"},
  {n:"앤로보틱스",c:"138360",m:"KQ"},
  {n:"앤씨앤",c:"092600",m:"KQ"},
  {n:"앱코",c:"129890",m:"KQ"},
  {n:"앱클론",c:"174900",m:"KQ"},
  {n:"앱토크롬",c:"109960",m:"KQ"},
  {n:"앱튼",c:"270520",m:"KQ"},
  {n:"야스",c:"255440",m:"KQ"},
  {n:"양지사",c:"030960",m:"KQ"},
  {n:"어보브반도체",c:"102120",m:"KQ"},
  {n:"얼라인드",c:"238120",m:"KQ"},
  {n:"에너토크",c:"019990",m:"KQ"},
  {n:"에넥스",c:"011090",m:"KS"},
  {n:"에르코스",c:"435570",m:"KQ"},
  {n:"에브리봇",c:"270660",m:"KQ"},
  {n:"에스넷",c:"038680",m:"KQ"},
  {n:"에스디바이오센서",c:"137310",m:"KS"},
  {n:"에스디생명공학",c:"217480",m:"KQ"},
  {n:"에스디시스템",c:"121890",m:"KQ"},
  {n:"에스바이오메딕스",c:"304360",m:"KQ"},
  {n:"에스비비테크",c:"389500",m:"KQ"},
  {n:"에스씨디",c:"042110",m:"KQ"},
  {n:"에스아이리소스",c:"065420",m:"KQ"},
  {n:"에스앤더블류",c:"103230",m:"KQ"},
  {n:"에스앤디",c:"260970",m:"KQ"},
  {n:"에스앤에스텍",c:"101490",m:"KQ"},
  {n:"에스에너지",c:"095910",m:"KQ"},
  {n:"에스에스알",c:"275630",m:"KQ"},
  {n:"에스에이엠티",c:"031330",m:"KQ"},
  {n:"에스에이티",c:"060540",m:"KQ"},
  {n:"에스엔시스",c:"0008Z0",m:"KQ"},
  {n:"에스엘",c:"005850",m:"KS"},
  {n:"에스엘에스바이오",c:"246250",m:"KQ"},
  {n:"에스엠",c:"041510",m:"KQ"},
  {n:"에스엠벡셀",c:"010580",m:"KS"},
  {n:"에스엠씨지",c:"460870",m:"KQ"},
  {n:"에스오에스랩",c:"464080",m:"KQ"},
  {n:"에스와이",c:"109610",m:"KQ"},
  {n:"에스와이스틸텍",c:"365330",m:"KQ"},
  {n:"에스원",c:"012750",m:"KS"},
  {n:"에스제이그룹",c:"306040",m:"KQ"},
  {n:"에스지헬스케어",c:"398120",m:"KQ"},
  {n:"에스케이증권제11호스팩",c:"472230",m:"KQ"},
  {n:"에스케이증권제12호스팩",c:"473000",m:"KQ"},
  {n:"에스케이증권제13호스팩",c:"473950",m:"KQ"},
  {n:"에스켐",c:"475660",m:"KQ"},
  {n:"에스코넥",c:"096630",m:"KQ"},
  {n:"에스텍",c:"069510",m:"KQ"},
  {n:"에스투더블유",c:"488280",m:"KQ"},
  {n:"에스트래픽",c:"234300",m:"KQ"},
  {n:"에스티아이",c:"039440",m:"KQ"},
  {n:"에스티오",c:"098660",m:"KQ"},
  {n:"에스티큐브",c:"052020",m:"KQ"},
  {n:"에스티팜",c:"237690",m:"KQ"},
  {n:"에스팀",c:"458350",m:"KQ"},
  {n:"에스폴리텍",c:"050760",m:"KQ"},
  {n:"에스프리즘",c:"288620",m:"KQ"},
  {n:"에스피소프트",c:"443670",m:"KQ"},
  {n:"에스피시스템스",c:"317830",m:"KQ"},
  {n:"에스피지",c:"058610",m:"KQ"},
  {n:"에쎈테크",c:"043340",m:"KQ"},
  {n:"에쓰씨엔지니어링",c:"023960",m:"KS"},
  {n:"에어레인",c:"163280",m:"KQ"},
  {n:"에어부산",c:"298690",m:"KS"},
  {n:"에이디테크놀로지",c:"200710",m:"KQ"},
  {n:"에이럭스",c:"475580",m:"KQ"},
  {n:"에이루트",c:"096690",m:"KQ"},
  {n:"에이블씨엔씨",c:"078520",m:"KS"},
  {n:"에이비엘바이오",c:"298380",m:"KQ"},
  {n:"에이비온",c:"203400",m:"KQ"},
  {n:"에이스침대",c:"003800",m:"KQ"},
  {n:"에이스테크",c:"088800",m:"KQ"},
  {n:"에이스토리",c:"241840",m:"KQ"},
  {n:"에이아이코리아",c:"364950",m:"KQ"},
  {n:"에이에스텍",c:"453860",m:"KQ"},
  {n:"에이에프더블류",c:"312610",m:"KQ"},
  {n:"에이엔피",c:"015260",m:"KS"},
  {n:"에이엘티",c:"172670",m:"KQ"},
  {n:"에이유브랜즈",c:"481070",m:"KQ"},
  {n:"에이전트AI",c:"060900",m:"KQ"},
  {n:"에이직랜드",c:"445090",m:"KQ"},
  {n:"에이치브이엠",c:"295310",m:"KQ"},
  {n:"에이치시티",c:"072990",m:"KQ"},
  {n:"에이치엔에스하이텍",c:"044990",m:"KQ"},
  {n:"에이치엘사이언스",c:"239610",m:"KQ"},
  {n:"에이치엘지노믹스",c:"0156T0",m:"KQ"},
  {n:"에이치엠넥스",c:"036170",m:"KQ"},
  {n:"에이치엠씨제7호스팩",c:"477340",m:"KQ"},
  {n:"에이치와이티씨",c:"148930",m:"KQ"},
  {n:"에이치케이",c:"044780",m:"KQ"},
  {n:"에이치피오",c:"357230",m:"KQ"},
  {n:"에이텀",c:"355690",m:"KQ"},
  {n:"에이테크솔루션",c:"071670",m:"KQ"},
  {n:"에이텍",c:"045660",m:"KQ"},
  {n:"에이텍모빌리티",c:"224110",m:"KQ"},
  {n:"에이티넘인베스트",c:"021080",m:"KQ"},
  {n:"에이팩트",c:"200470",m:"KQ"},
  {n:"에이프로",c:"262260",m:"KQ"},
  {n:"에이프로젠",c:"007460",m:"KS"},
  {n:"에이프로젠바이오로직스",c:"003060",m:"KS"},
  {n:"에이프릴바이오",c:"397030",m:"KQ"},
  {n:"에이플러스에셋",c:"244920",m:"KS"},
  {n:"에이피알",c:"278470",m:"KS"},
  {n:"에임드바이오",c:"0009K0",m:"KQ"},
  {n:"에치에프알",c:"230240",m:"KQ"},
  {n:"에코글로우",c:"159910",m:"KQ"},
  {n:"에코볼트",c:"097780",m:"KQ"},
  {n:"에코심플렉스",c:"038870",m:"KQ"},
  {n:"에코아이",c:"448280",m:"KQ"},
  {n:"에코앤드림",c:"101360",m:"KQ"},
  {n:"에코캡",c:"128540",m:"KQ"},
  {n:"에코프로",c:"086520",m:"KQ"},
  {n:"에코프로머티",c:"450080",m:"KS"},
  {n:"에코프로비엠",c:"247540",m:"KQ"},
  {n:"에코프로에이치엔",c:"383310",m:"KQ"},
  {n:"에코플라스틱",c:"038110",m:"KQ"},
  {n:"에프알텍",c:"073540",m:"KQ"},
  {n:"에프앤가이드",c:"064850",m:"KQ"},
  {n:"에프에스티",c:"036810",m:"KQ"},
  {n:"에프엔씨엔터",c:"173940",m:"KQ"},
  {n:"에프엔에스테크",c:"083500",m:"KQ"},
  {n:"에피소드컴퍼니",c:"317530",m:"KQ"},
  {n:"엑사이엔씨",c:"054940",m:"KQ"},
  {n:"엑세스바이오",c:"950130",m:"KQ"},
  {n:"엑셀세라퓨틱스",c:"373110",m:"KQ"},
  {n:"엑셈",c:"205100",m:"KQ"},
  {n:"엑스게이트",c:"356680",m:"KQ"},
  {n:"엑스페릭스",c:"317770",m:"KQ"},
  {n:"엑스플러스",c:"373200",m:"KQ"},
  {n:"엑시온그룹",c:"069920",m:"KQ"},
  {n:"엑시콘",c:"092870",m:"KQ"},
  {n:"엑시큐어하이트론",c:"019490",m:"KS"},
  {n:"엔바이오니아",c:"317870",m:"KQ"},
  {n:"엔브이에이치코리아",c:"067570",m:"KQ"},
  {n:"엔비알모션",c:"0004V0",m:"KQ"},
  {n:"엔비티",c:"236810",m:"KQ"},
  {n:"엔시스",c:"333620",m:"KQ"},
  {n:"엔시트론",c:"101400",m:"KQ"},
  {n:"엔알비",c:"475230",m:"KQ"},
  {n:"엔에이치스팩31호",c:"481890",m:"KQ"},
  {n:"엔에이치스팩32호",c:"0054V0",m:"KQ"},
  {n:"엔에이치스팩33호",c:"0130H0",m:"KQ"},
  {n:"엔에프씨",c:"265740",m:"KQ"},
  {n:"엔젠바이오",c:"354200",m:"KQ"},
  {n:"엔젤로보틱스",c:"455900",m:"KQ"},
  {n:"엔젯",c:"419080",m:"KQ"},
  {n:"엔지켐생명과학",c:"183490",m:"KQ"},
  {n:"엔케이",c:"085310",m:"KS"},
  {n:"엔케이젠바이오텍코리아",c:"182400",m:"KQ"},
  {n:"엔켐",c:"348370",m:"KQ"},
  {n:"엔텔스",c:"069410",m:"KQ"},
  {n:"엔투텍",c:"227950",m:"KQ"},
  {n:"엔피케이",c:"048830",m:"KQ"},
  {n:"엘디티",c:"096870",m:"KQ"},
  {n:"엘브이엠씨홀딩스",c:"900140",m:"KS"},
  {n:"엘앤씨바이오",c:"290650",m:"KQ"},
  {n:"엘앤에프",c:"066970",m:"KS"},
  {n:"엘앤케이바이오",c:"156100",m:"KQ"},
  {n:"엘에스스팩1호",c:"0041J0",m:"KQ"},
  {n:"엘엠에스",c:"073110",m:"KQ"},
  {n:"엘오티베큠",c:"083310",m:"KQ"},
  {n:"엘컴텍",c:"037950",m:"KQ"},
  {n:"엘케이켐",c:"489500",m:"KQ"},
  {n:"엘티씨",c:"170920",m:"KQ"},
  {n:"엠게임",c:"058630",m:"KQ"},
  {n:"엠디바이스",c:"226590",m:"KQ"},
  {n:"엠로",c:"058970",m:"KQ"},
  {n:"엠브레인",c:"169330",m:"KQ"},
  {n:"엠씨넥스",c:"097520",m:"KS"},
  {n:"엠아이큐브솔루션",c:"373170",m:"KQ"},
  {n:"엠아이텍",c:"179290",m:"KQ"},
  {n:"엠앤씨솔루션",c:"484870",m:"KS"},
  {n:"엠에스씨",c:"009780",m:"KQ"},
  {n:"엠에스오토텍",c:"123040",m:"KQ"},
  {n:"엠에프씨",c:"432980",m:"KQ"},
  {n:"엠엑스로보틱스",c:"007820",m:"KQ"},
  {n:"엠엑스온",c:"347890",m:"KQ"},
  {n:"엠오티",c:"413390",m:"KQ"},
  {n:"엠젠솔루션",c:"032790",m:"KQ"},
  {n:"엠케이전자",c:"033160",m:"KQ"},
  {n:"엠투엔",c:"033310",m:"KQ"},
  {n:"엠플러스",c:"259630",m:"KQ"},
  {n:"엣지파운드리",c:"105550",m:"KQ"},
  {n:"영림원소프트랩",c:"060850",m:"KQ"},
  {n:"영보화학",c:"014440",m:"KS"},
  {n:"영우디에스피",c:"143540",m:"KQ"},
  {n:"영원무역",c:"111770",m:"KS"},
  {n:"영원무역홀딩스",c:"009970",m:"KS"},
  {n:"영진약품",c:"003520",m:"KS"},
  {n:"영풍",c:"000670",m:"KS"},
  {n:"영화금속",c:"012280",m:"KS"},
  {n:"영화테크",c:"265560",m:"KQ"},
  {n:"영흥",c:"012160",m:"KS"},
  {n:"예림당",c:"036000",m:"KQ"},
  {n:"예선테크",c:"250930",m:"KQ"},
  {n:"예스24",c:"053280",m:"KQ"},
  {n:"예스티",c:"122640",m:"KQ"},
  {n:"오가노이드사이언스",c:"476040",m:"KQ"},
  {n:"오가닉티코스메틱",c:"900300",m:"KQ"},
  {n:"오공",c:"045060",m:"KQ"},
  {n:"오늘이엔엠",c:"192410",m:"KQ"},
  {n:"오디텍",c:"080520",m:"KQ"},
  {n:"오뚜기",c:"007310",m:"KS"},
  {n:"오로라",c:"039830",m:"KQ"},
  {n:"오로스테크놀로지",c:"322310",m:"KQ"},
  {n:"오르비텍",c:"046120",m:"KQ"},
  {n:"오름테라퓨틱",c:"475830",m:"KQ"},
  {n:"오리엔탈정공",c:"014940",m:"KQ"},
  {n:"오리엔트바이오",c:"002630",m:"KS"},
  {n:"오리엔트정공",c:"065500",m:"KQ"},
  {n:"오리온",c:"271560",m:"KS"},
  {n:"오리온홀딩스",c:"001800",m:"KS"},
  {n:"오리콤",c:"010470",m:"KQ"},
  {n:"오브젠",c:"417860",m:"KQ"},
  {n:"오비고",c:"352910",m:"KQ"},
  {n:"오상자이엘",c:"053980",m:"KQ"},
  {n:"오상헬스케어",c:"036220",m:"KQ"},
  {n:"오성첨단소재",c:"052420",m:"KQ"},
  {n:"오션인더블유",c:"052300",m:"KQ"},
  {n:"오스코텍",c:"039200",m:"KQ"},
  {n:"오스테오닉",c:"226400",m:"KQ"},
  {n:"오스템",c:"031510",m:"KQ"},
  {n:"오아",c:"342870",m:"KQ"},
  {n:"오에스피",c:"368970",m:"KQ"},
  {n:"오이솔루션",c:"138080",m:"KQ"},
  {n:"오킨스전자",c:"080580",m:"KQ"},
  {n:"오텍",c:"067170",m:"KQ"},
  {n:"오토앤",c:"353590",m:"KQ"},
  {n:"오파스넷",c:"173130",m:"KQ"},
  {n:"오픈놀",c:"440320",m:"KQ"},
  {n:"오픈베이스",c:"049480",m:"KQ"},
  {n:"오픈엣지테크놀로지",c:"394280",m:"KQ"},
  {n:"온코닉테라퓨틱스",c:"476060",m:"KQ"},
  {n:"온코크로스",c:"382150",m:"KQ"},
  {n:"온타이드",c:"005320",m:"KS"},
  {n:"올리패스",c:"244460",m:"KQ"},
  {n:"올릭스",c:"226950",m:"KQ"},
  {n:"옴니시스템",c:"057540",m:"KQ"},
  {n:"옵투스제약",c:"131030",m:"KQ"},
  {n:"옵트론텍",c:"082210",m:"KQ"},
  {n:"옵티시스",c:"109080",m:"KQ"},
  {n:"옵티코어",c:"380540",m:"KQ"},
  {n:"옵티팜",c:"153710",m:"KQ"},
  {n:"와이랩",c:"432430",m:"KQ"},
  {n:"와이바이오로직스",c:"338840",m:"KQ"},
  {n:"와이솔",c:"122990",m:"KQ"},
  {n:"와이씨",c:"232140",m:"KQ"},
  {n:"와이씨켐",c:"112290",m:"KQ"},
  {n:"와이어블",c:"065530",m:"KQ"},
  {n:"와이엔텍",c:"067900",m:"KQ"},
  {n:"와이엠",c:"007530",m:"KQ"},
  {n:"와이엠씨",c:"155650",m:"KQ"},
  {n:"와이엠텍",c:"273640",m:"KQ"},
  {n:"와이엠티",c:"251370",m:"KQ"},
  {n:"와이제이링크",c:"209640",m:"KQ"},
  {n:"와이즈넛",c:"096250",m:"KQ"},
  {n:"와이즈버즈",c:"273060",m:"KQ"},
  {n:"와이지-원",c:"019210",m:"KQ"},
  {n:"와이지엔터테인먼트",c:"122870",m:"KQ"},
  {n:"와이투솔루션",c:"011690",m:"KS"},
  {n:"와토스코리아",c:"079000",m:"KQ"},
  {n:"우듬지팜",c:"403490",m:"KQ"},
  {n:"우리금융지주",c:"316140",m:"KS"},
  {n:"우리기술",c:"032820",m:"KQ"},
  {n:"우리기술투자",c:"041190",m:"KQ"},
  {n:"우리넷",c:"115440",m:"KQ"},
  {n:"우리로",c:"046970",m:"KQ"},
  {n:"우리바이오",c:"082850",m:"KQ"},
  {n:"우리산업",c:"215360",m:"KQ"},
  {n:"우리산업홀딩스",c:"072470",m:"KQ"},
  {n:"우리손에프앤지",c:"073560",m:"KQ"},
  {n:"우리엔터프라이즈",c:"037400",m:"KQ"},
  {n:"우리이앤엘하루틴",c:"153490",m:"KQ"},
  {n:"우림피티에스",c:"101170",m:"KQ"},
  {n:"우성",c:"006980",m:"KS"},
  {n:"우성머티리얼스",c:"011300",m:"KS"},
  {n:"우신시스템",c:"017370",m:"KS"},
  {n:"우양",c:"103840",m:"KQ"},
  {n:"우양에이치씨",c:"101970",m:"KQ"},
  {n:"우원개발",c:"046940",m:"KQ"},
  {n:"우주일렉트로",c:"065680",m:"KQ"},
  {n:"우진",c:"105840",m:"KS"},
  {n:"우진비앤지",c:"018620",m:"KQ"},
  {n:"우진아이엔에스",c:"010400",m:"KS"},
  {n:"우진엔텍",c:"457550",m:"KQ"},
  {n:"우진플라임",c:"049800",m:"KS"},
  {n:"웅진",c:"016880",m:"KS"},
  {n:"웅진씽크빅",c:"095720",m:"KS"},
  {n:"워트",c:"396470",m:"KQ"},
  {n:"원림",c:"005820",m:"KS"},
  {n:"원바이오젠",c:"307280",m:"KQ"},
  {n:"원익",c:"032940",m:"KQ"},
  {n:"원익IPS",c:"240810",m:"KQ"},
  {n:"원익QnC",c:"074600",m:"KQ"},
  {n:"원익머트리얼즈",c:"104830",m:"KQ"},
  {n:"원익큐브",c:"014190",m:"KQ"},
  {n:"원익피앤이",c:"217820",m:"KQ"},
  {n:"원익홀딩스",c:"030530",m:"KQ"},
  {n:"원일특강",c:"012620",m:"KQ"},
  {n:"원일티엔아이",c:"136150",m:"KQ"},
  {n:"원준",c:"382840",m:"KQ"},
  {n:"원텍",c:"336570",m:"KQ"},
  {n:"원티드랩",c:"376980",m:"KQ"},
  {n:"원풍",c:"008370",m:"KQ"},
  {n:"원풍물산",c:"008290",m:"KQ"},
  {n:"월덱스",c:"101160",m:"KQ"},
  {n:"웨이버스",c:"336060",m:"KQ"},
  {n:"웨이브일렉트로",c:"095270",m:"KQ"},
  {n:"웨이비스",c:"289930",m:"KQ"},
  {n:"웰크론",c:"065950",m:"KQ"},
  {n:"웰크론한텍",c:"076080",m:"KQ"},
  {n:"웰킵스하이텍",c:"043590",m:"KQ"},
  {n:"웹스",c:"196700",m:"KQ"},
  {n:"웹젠",c:"069080",m:"KQ"},
  {n:"웹케시",c:"053580",m:"KQ"},
  {n:"위너스일렉",c:"479960",m:"KQ"},
  {n:"위닉스",c:"044340",m:"KQ"},
  {n:"위더스제약",c:"330350",m:"KQ"},
  {n:"위드텍",c:"348350",m:"KQ"},
  {n:"위메이드",c:"112040",m:"KQ"},
  {n:"위메이드맥스",c:"101730",m:"KQ"},
  {n:"위메이드플레이",c:"123420",m:"KQ"},
  {n:"위세아이텍",c:"065370",m:"KQ"},
  {n:"위즈코프",c:"038620",m:"KQ"},
  {n:"위지트",c:"036090",m:"KQ"},
  {n:"위츠",c:"459100",m:"KQ"},
  {n:"윈스테크넷",c:"136540",m:"KQ"},
  {n:"윈팩",c:"097800",m:"KQ"},
  {n:"윈하이텍",c:"192390",m:"KQ"},
  {n:"윌비스",c:"008600",m:"KS"},
  {n:"윙스풋",c:"335870",m:"KQ"},
  {n:"윙입푸드",c:"900340",m:"KQ"},
  {n:"유나이티드제약",c:"033270",m:"KS"},
  {n:"유니드",c:"014830",m:"KS"},
  {n:"유니드비티플러스",c:"446070",m:"KS"},
  {n:"유니셈",c:"036200",m:"KQ"},
  {n:"유니슨",c:"018000",m:"KQ"},
  {n:"유니온",c:"000910",m:"KS"},
  {n:"유니온머티리얼",c:"047400",m:"KS"},
  {n:"유니온바이오메트릭스",c:"203450",m:"KQ"},
  {n:"유니켐",c:"011330",m:"KS"},
  {n:"유니퀘스트",c:"077500",m:"KS"},
  {n:"유니크",c:"011320",m:"KQ"},
  {n:"유니테스트",c:"086390",m:"KQ"},
  {n:"유니테크노",c:"241690",m:"KQ"},
  {n:"유니트론텍",c:"142210",m:"KQ"},
  {n:"유디엠텍",c:"389680",m:"KQ"},
  {n:"유라클",c:"088340",m:"KQ"},
  {n:"유라테크",c:"048430",m:"KQ"},
  {n:"유바이오로직스",c:"206650",m:"KQ"},
  {n:"유비벨록스",c:"089850",m:"KQ"},
  {n:"유비온",c:"084440",m:"KQ"},
  {n:"유비쿼스",c:"264450",m:"KQ"},
  {n:"유비쿼스홀딩스",c:"078070",m:"KQ"},
  {n:"유성기업",c:"002920",m:"KS"},
  {n:"유성티엔에스",c:"024800",m:"KQ"},
  {n:"유수홀딩스",c:"000700",m:"KS"},
  {n:"유신",c:"054930",m:"KQ"},
  {n:"유아이디",c:"069330",m:"KQ"},
  {n:"유아이엘",c:"049520",m:"KQ"},
  {n:"유안타제15호스팩",c:"473050",m:"KQ"},
  {n:"유안타제16호스팩",c:"474490",m:"KQ"},
  {n:"유안타제17호스팩",c:"493790",m:"KQ"},
  {n:"유안타증권",c:"003470",m:"KS"},
  {n:"유안타증권우",c:"003475",m:"KS"},
  {n:"유에스티",c:"263770",m:"KQ"},
  {n:"유엔젤",c:"072130",m:"KS"},
  {n:"유유제약",c:"000220",m:"KS"},
  {n:"유유제약1우",c:"000225",m:"KS"},
  {n:"유유제약2우B",c:"000227",m:"KS"},
  {n:"유일로보틱스",c:"388720",m:"KQ"},
  {n:"유진 챔피언중단기크레딧 X클래스",c:"0120X0",m:"KS"},
  {n:"유진기업",c:"023410",m:"KQ"},
  {n:"유진로봇",c:"056080",m:"KQ"},
  {n:"유진스팩10호",c:"468760",m:"KQ"},
  {n:"유진스팩11호",c:"488060",m:"KQ"},
  {n:"유진스팩12호",c:"0105P0",m:"KQ"},
  {n:"유진테크",c:"084370",m:"KQ"},
  {n:"유진테크놀로지",c:"240600",m:"KQ"},
  {n:"유진투자증권",c:"001200",m:"KS"},
  {n:"유티아이",c:"179900",m:"KQ"},
  {n:"유틸렉스",c:"263050",m:"KQ"},
  {n:"유한양행",c:"000100",m:"KS"},
  {n:"유한양행우",c:"000105",m:"KS"},
  {n:"유화증권",c:"003460",m:"KS"},
  {n:"유화증권우",c:"003465",m:"KS"},
  {n:"육일씨엔에쓰",c:"191410",m:"KQ"},
  {n:"윤성에프앤씨",c:"372170",m:"KQ"},
  {n:"율촌",c:"146060",m:"KQ"},
  {n:"율촌화학",c:"008730",m:"KS"},
  {n:"이건산업",c:"008250",m:"KS"},
  {n:"이건홀딩스",c:"039020",m:"KQ"},
  {n:"이구산업",c:"025820",m:"KS"},
  {n:"이글루",c:"067920",m:"KQ"},
  {n:"이글벳",c:"044960",m:"KQ"},
  {n:"이노뎁",c:"303530",m:"KQ"},
  {n:"이노메트리",c:"302430",m:"KQ"},
  {n:"이노션",c:"214320",m:"KS"},
  {n:"이노스페이스",c:"462350",m:"KQ"},
  {n:"이노시뮬레이션",c:"274400",m:"KQ"},
  {n:"이노에이엑스",c:"296640",m:"KQ"},
  {n:"이노인스트루먼트",c:"215790",m:"KQ"},
  {n:"이노진",c:"344860",m:"KQ"},
  {n:"이노테나",c:"333050",m:"KQ"},
  {n:"이노테크",c:"469610",m:"KQ"},
  {n:"이녹스",c:"088390",m:"KQ"},
  {n:"이녹스첨단소재",c:"272290",m:"KQ"},
  {n:"이니텍",c:"053350",m:"KQ"},
  {n:"이닉스",c:"452400",m:"KQ"},
  {n:"이랜시스",c:"264850",m:"KQ"},
  {n:"이랜텍",c:"054210",m:"KQ"},
  {n:"이렘",c:"009730",m:"KQ"},
  {n:"이루온",c:"065440",m:"KQ"},
  {n:"이리츠코크렙",c:"088260",m:"KS"},
  {n:"이마트",c:"139480",m:"KS"},
  {n:"이뮨온시아",c:"424870",m:"KQ"},
  {n:"이미지스",c:"115610",m:"KQ"},
  {n:"이베스트스팩6호",c:"478110",m:"KQ"},
  {n:"이브이첨단소재",c:"131400",m:"KQ"},
  {n:"이삭엔지니어링",c:"351330",m:"KQ"},
  {n:"이상네트웍스",c:"080010",m:"KQ"},
  {n:"이수스페셜티케미컬",c:"457190",m:"KS"},
  {n:"이수앱지스",c:"086890",m:"KQ"},
  {n:"이수페타시스",c:"007660",m:"KS"},
  {n:"이수화학",c:"005950",m:"KS"},
  {n:"이스타코",c:"015020",m:"KS"},
  {n:"이스트소프트",c:"047560",m:"KQ"},
  {n:"이스트에이드",c:"239340",m:"KQ"},
  {n:"이씨에스",c:"067010",m:"KQ"},
  {n:"이엔셀",c:"456070",m:"KQ"},
  {n:"이엔에프테크놀로지",c:"102710",m:"KQ"},
  {n:"이엔플러스",c:"074610",m:"KS"},
  {n:"이엘씨",c:"041520",m:"KQ"},
  {n:"이엘피",c:"063760",m:"KQ"},
  {n:"이엠넷",c:"123570",m:"KQ"},
  {n:"이엠앤아이",c:"083470",m:"KQ"},
  {n:"이엠텍",c:"091120",m:"KQ"},
  {n:"이연제약",c:"102460",m:"KS"},
  {n:"이오테크닉스",c:"039030",m:"KQ"},
  {n:"이오플로우",c:"294090",m:"KQ"},
  {n:"이원컴포텍",c:"088290",m:"KQ"},
  {n:"이월드",c:"084680",m:"KS"},
  {n:"이지바이오",c:"353810",m:"KQ"},
  {n:"이지스",c:"261520",m:"KQ"},
  {n:"이지스레지던스리츠",c:"350520",m:"KS"},
  {n:"이지스밸류플러스리츠",c:"334890",m:"KS"},
  {n:"이지케어텍",c:"099750",m:"KQ"},
  {n:"이지트로닉스",c:"377330",m:"KQ"},
  {n:"이지홀딩스",c:"035810",m:"KQ"},
  {n:"이크레더블",c:"092130",m:"KQ"},
  {n:"이퓨쳐",c:"134060",m:"KQ"},
  {n:"이화공영",c:"001840",m:"KQ"},
  {n:"이화산업",c:"000760",m:"KS"},
  {n:"인디에프",c:"014990",m:"KS"},
  {n:"인바디",c:"041830",m:"KQ"},
  {n:"인바이오",c:"352940",m:"KQ"},
  {n:"인바이오젠",c:"101140",m:"KS"},
  {n:"인베니아",c:"079950",m:"KQ"},
  {n:"인벤테라",c:"0007J0",m:"KQ"},
  {n:"인벤티지랩",c:"389470",m:"KQ"},
  {n:"인산가",c:"277410",m:"KQ"},
  {n:"인선이엔티",c:"060150",m:"KQ"},
  {n:"인성정보",c:"033230",m:"KQ"},
  {n:"인스웨이브",c:"450520",m:"KQ"},
  {n:"인스피언",c:"465480",m:"KQ"},
  {n:"인제니아테라퓨틱스(Reg.S)",c:"950260",m:"KQ"},
  {n:"인지디스플레",c:"037330",m:"KQ"},
  {n:"인지소프트",c:"100030",m:"KQ"},
  {n:"인지컨트롤스",c:"023800",m:"KS"},
  {n:"인천도시가스",c:"034590",m:"KS"},
  {n:"인카금융서비스",c:"211050",m:"KQ"},
  {n:"인콘",c:"083640",m:"KQ"},
  {n:"인크레더블버즈",c:"064090",m:"KQ"},
  {n:"인크로스",c:"216050",m:"KQ"},
  {n:"인탑스",c:"049070",m:"KQ"},
  {n:"인터로조",c:"119610",m:"KQ"},
  {n:"인터엠",c:"017250",m:"KQ"},
  {n:"인터지스",c:"129260",m:"KS"},
  {n:"인터플렉스",c:"051370",m:"KQ"},
  {n:"인텍플러스",c:"064290",m:"KQ"},
  {n:"인텔리안테크",c:"189300",m:"KQ"},
  {n:"인투셀",c:"287840",m:"KQ"},
  {n:"인트론바이오",c:"048530",m:"KQ"},
  {n:"인티큐브",c:"070590",m:"KQ"},
  {n:"인팩",c:"023810",m:"KS"},
  {n:"인포바인",c:"115310",m:"KQ"},
  {n:"인포뱅크",c:"039290",m:"KQ"},
  {n:"인피니트헬스케어",c:"071200",m:"KQ"},
  {n:"인화정공",c:"101930",m:"KQ"},
  {n:"일동제약",c:"249420",m:"KS"},
  {n:"일동홀딩스",c:"000230",m:"KS"},
  {n:"일성건설",c:"013360",m:"KS"},
  {n:"일성아이에스",c:"003120",m:"KS"},
  {n:"일승",c:"333430",m:"KQ"},
  {n:"일신바이오",c:"068330",m:"KQ"},
  {n:"일신방직",c:"003200",m:"KS"},
  {n:"일신석재",c:"007110",m:"KS"},
  {n:"일양약품",c:"007570",m:"KS"},
  {n:"일양약품우",c:"007575",m:"KS"},
  {n:"일월지엠엘",c:"178780",m:"KQ"},
  {n:"일지테크",c:"019540",m:"KQ"},
  {n:"일진다이아",c:"081000",m:"KS"},
  {n:"일진디스플",c:"020760",m:"KS"},
  {n:"일진전기",c:"103590",m:"KS"},
  {n:"일진파워",c:"094820",m:"KQ"},
  {n:"일진하이솔루스",c:"271940",m:"KS"},
  {n:"일진홀딩스",c:"015860",m:"KS"},
  {n:"잇츠한불",c:"226320",m:"KS"},
  {n:"잉글우드랩",c:"950140",m:"KQ"},
  {n:"잉크테크",c:"049550",m:"KQ"},
  {n:"자람테크놀로지",c:"389020",m:"KQ"},
  {n:"자비스",c:"254120",m:"KQ"},
  {n:"자연과환경",c:"043910",m:"KQ"},
  {n:"자이글",c:"234920",m:"KQ"},
  {n:"자이언트스텝",c:"289220",m:"KQ"},
  {n:"자이에스앤디",c:"317400",m:"KS"},
  {n:"자화전자",c:"033240",m:"KS"},
  {n:"재영솔루텍",c:"049630",m:"KQ"},
  {n:"저스템",c:"417840",m:"KQ"},
  {n:"전방",c:"000950",m:"KS"},
  {n:"전진건설로봇",c:"079900",m:"KS"},
  {n:"전진바이오팜",c:"110020",m:"KQ"},
  {n:"정다운",c:"208140",m:"KQ"},
  {n:"정상제이엘에스",c:"040420",m:"KQ"},
  {n:"정원엔시스",c:"045510",m:"KQ"},
  {n:"제너셈",c:"217190",m:"KQ"},
  {n:"제넥신",c:"095700",m:"KQ"},
  {n:"제노레이",c:"122310",m:"KQ"},
  {n:"제노코",c:"361390",m:"KQ"},
  {n:"제놀루션",c:"225220",m:"KQ"},
  {n:"제닉",c:"123330",m:"KQ"},
  {n:"제닉스로보틱스",c:"381620",m:"KQ"},
  {n:"제로투세븐",c:"159580",m:"KQ"},
  {n:"제룡산업",c:"147830",m:"KQ"},
  {n:"제룡전기",c:"033100",m:"KQ"},
  {n:"제우스",c:"079370",m:"KQ"},
  {n:"제이브이엠",c:"054950",m:"KQ"},
  {n:"제이스로보틱스",c:"090470",m:"KQ"},
  {n:"제이스코홀딩스",c:"023440",m:"KQ"},
  {n:"제이씨케미칼",c:"137950",m:"KQ"},
  {n:"제이씨현시스템",c:"033320",m:"KQ"},
  {n:"제이아이테크",c:"417500",m:"KQ"},
  {n:"제이알글로벌리츠",c:"348950",m:"KS"},
  {n:"제이앤티씨",c:"204270",m:"KQ"},
  {n:"제이에스링크",c:"127120",m:"KQ"},
  {n:"제이에스코퍼레이션",c:"194370",m:"KS"},
  {n:"제이에스티나",c:"026040",m:"KQ"},
  {n:"제이엔비",c:"452160",m:"KQ"},
  {n:"제이엔케이글로벌",c:"126880",m:"KQ"},
  {n:"제이엘케이",c:"322510",m:"KQ"},
  {n:"제이엠아이",c:"033050",m:"KQ"},
  {n:"제이엠티",c:"094970",m:"KQ"},
  {n:"제이오",c:"418550",m:"KQ"},
  {n:"제이케이시냅스",c:"060230",m:"KQ"},
  {n:"제이투케이바이오",c:"420570",m:"KQ"},
  {n:"제이티",c:"089790",m:"KQ"},
  {n:"제이피아이헬스케어",c:"0010V0",m:"KQ"},
  {n:"제일기획",c:"030000",m:"KS"},
  {n:"제일약품",c:"271980",m:"KS"},
  {n:"제일엠앤에스",c:"412540",m:"KQ"},
  {n:"제일연마",c:"001560",m:"KS"},
  {n:"제일일렉트릭",c:"199820",m:"KQ"},
  {n:"제일테크노스",c:"038010",m:"KQ"},
  {n:"제일파마홀딩스",c:"002620",m:"KS"},
  {n:"제주반도체",c:"080220",m:"KQ"},
  {n:"제주은행",c:"006220",m:"KS"},
  {n:"제주항공",c:"089590",m:"KS"},
  {n:"제테마",c:"216080",m:"KQ"},
  {n:"젝시믹스",c:"337930",m:"KQ"},
  {n:"젠큐릭스",c:"229000",m:"KQ"},
  {n:"젬백스",c:"082270",m:"KQ"},
  {n:"져스텍",c:"153890",m:"KQ"},
  {n:"조광페인트",c:"004910",m:"KS"},
  {n:"조광피혁",c:"004700",m:"KS"},
  {n:"조비",c:"001550",m:"KS"},
  {n:"조선내화",c:"462520",m:"KS"},
  {n:"조선선재",c:"120030",m:"KS"},
  {n:"조아제약",c:"034940",m:"KQ"},
  {n:"조이시티",c:"067000",m:"KQ"},
  {n:"조이웍스앤코",c:"309930",m:"KQ"},
  {n:"조일알미늄",c:"018470",m:"KS"},
  {n:"조흥",c:"002600",m:"KS"},
  {n:"졸스",c:"018700",m:"KQ"},
  {n:"종근당",c:"185750",m:"KS"},
  {n:"종근당바이오",c:"063160",m:"KS"},
  {n:"종근당홀딩스",c:"001630",m:"KS"},
  {n:"좋은사람들",c:"033340",m:"KQ"},
  {n:"주성엔지니어링",c:"036930",m:"KQ"},
  {n:"주성코퍼레이션",c:"109070",m:"KS"},
  {n:"주연테크",c:"044380",m:"KS"},
  {n:"중앙백신",c:"072020",m:"KQ"},
  {n:"중앙에너비스",c:"000440",m:"KQ"},
  {n:"중앙첨단소재",c:"051980",m:"KQ"},
  {n:"지구홀딩스",c:"221800",m:"KQ"},
  {n:"지노믹트리",c:"228760",m:"KQ"},
  {n:"지놈앤컴퍼니",c:"314130",m:"KQ"},
  {n:"지누스",c:"013890",m:"KS"},
  {n:"지니너스",c:"389030",m:"KQ"},
  {n:"지니언스",c:"263860",m:"KQ"},
  {n:"지니틱스",c:"303030",m:"KQ"},
  {n:"지란지교시큐리티",c:"208350",m:"KQ"},
  {n:"지슨",c:"446840",m:"KQ"},
  {n:"지씨셀",c:"144510",m:"KQ"},
  {n:"지씨지놈",c:"340450",m:"KQ"},
  {n:"지아이에스",c:"306620",m:"KQ"},
  {n:"지아이이노베이션",c:"358570",m:"KQ"},
  {n:"지아이텍",c:"382480",m:"KQ"},
  {n:"지앤비에스 에코",c:"382800",m:"KQ"},
  {n:"지어소프트",c:"051160",m:"KQ"},
  {n:"지에스이",c:"053050",m:"KQ"},
  {n:"지에프씨생명과학",c:"388610",m:"KQ"},
  {n:"지에프아이",c:"493330",m:"KQ"},
  {n:"지엔씨에너지",c:"119850",m:"KQ"},
  {n:"지엔코",c:"065060",m:"KQ"},
  {n:"지엘팜텍",c:"204840",m:"KQ"},
  {n:"지엠비코리아",c:"013870",m:"KS"},
  {n:"지역난방공사",c:"071320",m:"KS"},
  {n:"지오엘리먼트",c:"311320",m:"KQ"},
  {n:"지투지바이오",c:"456160",m:"KQ"},
  {n:"지투파워",c:"388050",m:"KQ"},
  {n:"진도",c:"088790",m:"KS"},
  {n:"진로발효",c:"018120",m:"KQ"},
  {n:"진매트릭스",c:"109820",m:"KQ"},
  {n:"진바이오텍",c:"086060",m:"KQ"},
  {n:"진성티이씨",c:"036890",m:"KQ"},
  {n:"진시스템",c:"363250",m:"KQ"},
  {n:"진양산업",c:"003780",m:"KS"},
  {n:"진양제약",c:"007370",m:"KQ"},
  {n:"진양폴리",c:"010640",m:"KS"},
  {n:"진양홀딩스",c:"100250",m:"KS"},
  {n:"진양화학",c:"051630",m:"KS"},
  {n:"진에어",c:"272450",m:"KS"},
  {n:"진영",c:"285800",m:"KQ"},
  {n:"진원생명과학",c:"011000",m:"KS"},
  {n:"진흥기업",c:"002780",m:"KS"},
  {n:"진흥기업2우B",c:"002787",m:"KS"},
  {n:"진흥기업우B",c:"002785",m:"KS"},
  {n:"차AI헬스케어",c:"025620",m:"KS"},
  {n:"차바이오텍",c:"085660",m:"KQ"},
  {n:"차이커뮤니케이션",c:"351870",m:"KQ"},
  {n:"참엔지니어링",c:"009310",m:"KS"},
  {n:"참좋은여행",c:"094850",m:"KQ"},
  {n:"창해에탄올",c:"004650",m:"KQ"},
  {n:"채비",c:"0011T0",m:"KQ"},
  {n:"천보",c:"278280",m:"KQ"},
  {n:"천일고속",c:"000650",m:"KS"},
  {n:"청담글로벌",c:"362320",m:"KQ"},
  {n:"청보",c:"013720",m:"KQ"},
  {n:"체리부로",c:"066360",m:"KQ"},
  {n:"체시스",c:"033250",m:"KS"},
  {n:"초록뱀미디어",c:"047820",m:"KQ"},
  {n:"츌립앤사이언스",c:"291650",m:"KQ"},
  {n:"칩스앤미디어",c:"094360",m:"KQ"},
  {n:"카나프테라퓨틱스",c:"0082N0",m:"KQ"},
  {n:"카스",c:"016920",m:"KQ"},
  {n:"카이노스메드",c:"284620",m:"KQ"},
  {n:"카카오",c:"035720",m:"KS"},
  {n:"카카오게임즈",c:"293490",m:"KQ"},
  {n:"카카오뱅크",c:"323410",m:"KS"},
  {n:"카카오페이",c:"377300",m:"KS"},
  {n:"카티스",c:"140430",m:"KQ"},
  {n:"카페24",c:"042000",m:"KQ"},
  {n:"카프로",c:"006380",m:"KS"},
  {n:"캐리",c:"313760",m:"KQ"},
  {n:"캐스텍코리아",c:"071850",m:"KQ"},
  {n:"캐프",c:"198080",m:"KQ"},
  {n:"캔버스엔",c:"210120",m:"KQ"},
  {n:"캠시스",c:"050110",m:"KQ"},
  {n:"캡스톤파트너스",c:"452300",m:"KQ"},
  {n:"컨텍",c:"451760",m:"KQ"},
  {n:"컬러레이",c:"900310",m:"KQ"},
  {n:"컴투스",c:"078340",m:"KQ"},
  {n:"컴투스엔",c:"291230",m:"KQ"},
  {n:"컴투스홀딩스",c:"063080",m:"KQ"},
  {n:"컴퍼니케이",c:"307930",m:"KQ"},
  {n:"케스피온",c:"079190",m:"KQ"},
  {n:"케어랩스",c:"263700",m:"KQ"},
  {n:"케어젠",c:"214370",m:"KQ"},
  {n:"케이디켐",c:"221980",m:"KQ"},
  {n:"케이바이오랩스",c:"038530",m:"KQ"},
  {n:"케이뱅크",c:"279570",m:"KS"},
  {n:"케이비아이동국실업",c:"001620",m:"KS"},
  {n:"케이사인",c:"192250",m:"KQ"},
  {n:"케이쓰리아이",c:"431190",m:"KQ"},
  {n:"케이씨",c:"029460",m:"KS"},
  {n:"케이씨에스",c:"115500",m:"KQ"},
  {n:"케이씨텍",c:"281820",m:"KS"},
  {n:"케이씨티",c:"089150",m:"KQ"},
  {n:"케이씨피드",c:"025880",m:"KQ"},
  {n:"케이아이엔엑스",c:"093320",m:"KQ"},
  {n:"케이알엠",c:"093640",m:"KQ"},
  {n:"케이앤에스아이앤씨",c:"487400",m:"KQ"},
  {n:"케이에스피",c:"073010",m:"KQ"},
  {n:"케이엔더블유",c:"105330",m:"KQ"},
  {n:"케이엔솔",c:"053080",m:"KQ"},
  {n:"케이엔알시스템",c:"199430",m:"KQ"},
  {n:"케이엔에스",c:"432470",m:"KQ"},
  {n:"케이엔제이",c:"272110",m:"KQ"},
  {n:"케이엘넷",c:"039420",m:"KQ"},
  {n:"케이엠",c:"083550",m:"KQ"},
  {n:"케이엠더블유",c:"032500",m:"KQ"},
  {n:"케이엠제약",c:"225430",m:"KQ"},
  {n:"케이옥션",c:"102370",m:"KQ"},
  {n:"케이웨더",c:"068100",m:"KQ"},
  {n:"케이이엠텍",c:"106080",m:"KQ"},
  {n:"케이지에이",c:"455180",m:"KQ"},
  {n:"케이카",c:"381970",m:"KS"},
  {n:"케이탑리츠",c:"145270",m:"KS"},
  {n:"케이티알파",c:"036030",m:"KQ"},
  {n:"케이프",c:"064820",m:"KQ"},
  {n:"케이피에프",c:"024880",m:"KQ"},
  {n:"케이피엠테크",c:"042040",m:"KQ"},
  {n:"케이피티유",c:"054410",m:"KQ"},
  {n:"케이피항공산업",c:"288180",m:"KQ"},
  {n:"케일럼",c:"258610",m:"KQ"},
  {n:"켄코아에어로스페이스",c:"274090",m:"KQ"},
  {n:"켐트로닉스",c:"089010",m:"KQ"},
  {n:"켐트로스",c:"220260",m:"KQ"},
  {n:"코나아이",c:"052400",m:"KQ"},
  {n:"코난테크놀로지",c:"402030",m:"KQ"},
  {n:"코닉오토메이션",c:"391710",m:"KQ"},
  {n:"코다코",c:"046070",m:"KQ"},
  {n:"코데즈컴바인",c:"047770",m:"KQ"},
  {n:"코디",c:"080530",m:"KQ"},
  {n:"코람코더원리츠",c:"417310",m:"KS"},
  {n:"코람코라이프인프라리츠",c:"357120",m:"KS"},
  {n:"코렌텍",c:"104540",m:"KQ"},
  {n:"코리아나",c:"027050",m:"KQ"},
  {n:"코리아써우",c:"007815",m:"KS"},
  {n:"코리아써키트",c:"007810",m:"KS"},
  {n:"코리아써키트2우B",c:"00781K",m:"KS"},
  {n:"코리아에셋투자증권",c:"190650",m:"KQ"},
  {n:"코리아에프티",c:"123410",m:"KQ"},
  {n:"코리안리",c:"003690",m:"KS"},
  {n:"코맥스",c:"036690",m:"KQ"},
  {n:"코메론",c:"049430",m:"KQ"},
  {n:"코미코",c:"183300",m:"KQ"},
  {n:"코미팜",c:"041960",m:"KQ"},
  {n:"코세스",c:"089890",m:"KQ"},
  {n:"코셈",c:"360350",m:"KQ"},
  {n:"코스나인",c:"082660",m:"KQ"},
  {n:"코스리거글로벌",c:"043710",m:"KQ"},
  {n:"코스맥스",c:"192820",m:"KS"},
  {n:"코스맥스비티아이",c:"044820",m:"KS"},
  {n:"코스맥스엔비티",c:"222040",m:"KQ"},
  {n:"코스메카코리아",c:"241710",m:"KQ"},
  {n:"코스모로보틱스",c:"439960",m:"KQ"},
  {n:"코스모신소재",c:"005070",m:"KS"},
  {n:"코스모화학",c:"005420",m:"KS"},
  {n:"코스텍시스",c:"355150",m:"KQ"},
  {n:"코아스",c:"071950",m:"KS"},
  {n:"코아스템켐온",c:"166480",m:"KQ"},
  {n:"코아시아",c:"045970",m:"KQ"},
  {n:"코아시아씨엠",c:"196450",m:"KQ"},
  {n:"코어라인소프트",c:"384470",m:"KQ"},
  {n:"코오롱",c:"002020",m:"KS"},
  {n:"코오롱글로벌",c:"003070",m:"KS"},
  {n:"코오롱글로벌우",c:"003075",m:"KS"},
  {n:"코오롱생명과학",c:"102940",m:"KQ"},
  {n:"코오롱우",c:"002025",m:"KS"},
  {n:"코오롱인더",c:"120110",m:"KS"},
  {n:"코오롱인더우",c:"120115",m:"KS"},
  {n:"코오롱티슈진",c:"950160",m:"KQ"},
  {n:"코웨이",c:"021240",m:"KS"},
  {n:"코위버",c:"056360",m:"KQ"},
  {n:"코윈테크",c:"282880",m:"KQ"},
  {n:"코이즈",c:"121850",m:"KQ"},
  {n:"코츠테크놀로지",c:"448710",m:"KQ"},
  {n:"코칩",c:"126730",m:"KQ"},
  {n:"코콤",c:"015710",m:"KQ"},
  {n:"코텍",c:"052330",m:"KQ"},
  {n:"코퍼스코리아",c:"322780",m:"KQ"},
  {n:"콘텐트리중앙",c:"036420",m:"KS"},
  {n:"콜마바이오텍",c:"215380",m:"KQ"},
  {n:"콜마비앤에이치",c:"200130",m:"KQ"},
  {n:"콜마홀딩스",c:"024720",m:"KS"},
  {n:"쿠콘",c:"294570",m:"KQ"},
  {n:"쿠쿠홀딩스",c:"192400",m:"KS"},
  {n:"쿠쿠홈시스",c:"284740",m:"KS"},
  {n:"쿼드메디슨",c:"464490",m:"KQ"},
  {n:"퀀타매트릭스",c:"317690",m:"KQ"},
  {n:"퀀텀레일",c:"070300",m:"KQ"},
  {n:"퀄리타스반도체",c:"432720",m:"KQ"},
  {n:"큐라클",c:"365270",m:"KQ"},
  {n:"큐라티스",c:"348080",m:"KQ"},
  {n:"큐렉소",c:"060280",m:"KQ"},
  {n:"큐로셀",c:"372320",m:"KQ"},
  {n:"큐로홀딩스",c:"051780",m:"KQ"},
  {n:"큐리언트",c:"115180",m:"KQ"},
  {n:"큐리오시스",c:"494120",m:"KQ"},
  {n:"큐리옥스바이오시스템즈",c:"445680",m:"KQ"},
  {n:"큐브엔터",c:"182360",m:"KQ"},
  {n:"큐알티",c:"405100",m:"KQ"},
  {n:"큐에스아이",c:"066310",m:"KQ"},
  {n:"큐에이드",c:"377460",m:"KQ"},
  {n:"큐캐피탈",c:"016600",m:"KQ"},
  {n:"크라우드웍스",c:"355390",m:"KQ"},
  {n:"크라운제과",c:"264900",m:"KS"},
  {n:"크라운제과우",c:"26490K",m:"KS"},
  {n:"크라운해태홀딩스",c:"005740",m:"KS"},
  {n:"크라운해태홀딩스우",c:"005745",m:"KS"},
  {n:"크래프톤",c:"259960",m:"KS"},
  {n:"크레버스",c:"096240",m:"KQ"},
  {n:"크레오에스지",c:"040350",m:"KQ"},
  {n:"크리스에프앤씨",c:"110790",m:"KQ"},
  {n:"크리스탈신소재",c:"900250",m:"KQ"},
  {n:"크린앤사이언스",c:"045520",m:"KQ"},
  {n:"클래시스",c:"214150",m:"KQ"},
  {n:"클로봇",c:"466100",m:"KQ"},
  {n:"클리오",c:"237880",m:"KQ"},
  {n:"키네마스터",c:"139670",m:"KQ"},
  {n:"키다리스튜디오",c:"020120",m:"KS"},
  {n:"키스트론",c:"475430",m:"KQ"},
  {n:"키움제10호스팩",c:"487720",m:"KQ"},
  {n:"키움제11호스팩",c:"489480",m:"KQ"},
  {n:"키움증권",c:"039490",m:"KS"},
  {n:"키움히어로제1호스팩",c:"466690",m:"KQ"},
  {n:"키움히어로제2호스팩",c:"0131D0",m:"KQ"},
  {n:"키이스트",c:"054780",m:"KQ"},
  {n:"킵스파마",c:"256940",m:"KQ"},
  {n:"타이거일렉",c:"219130",m:"KQ"},
  {n:"탑런토탈솔루션",c:"336680",m:"KQ"},
  {n:"탑머티리얼",c:"360070",m:"KQ"},
  {n:"탑엔지니어링",c:"065130",m:"KQ"},
  {n:"탑코미디어",c:"134580",m:"KQ"},
  {n:"태경비케이",c:"014580",m:"KS"},
  {n:"태경산업",c:"015890",m:"KS"},
  {n:"태경케미컬",c:"006890",m:"KS"},
  {n:"태광",c:"023160",m:"KQ"},
  {n:"태광산업",c:"003240",m:"KS"},
  {n:"태림포장",c:"011280",m:"KS"},
  {n:"태성",c:"323280",m:"KQ"},
  {n:"태양",c:"053620",m:"KQ"},
  {n:"태양금속",c:"004100",m:"KS"},
  {n:"태양금속우",c:"004105",m:"KS"},
  {n:"태영건설",c:"009410",m:"KS"},
  {n:"태영건설우",c:"009415",m:"KS"},
  {n:"태웅",c:"044490",m:"KQ"},
  {n:"태웅로직스",c:"124560",m:"KQ"},
  {n:"태원물산",c:"001420",m:"KS"},
  {n:"테고사이언스",c:"191420",m:"KQ"},
  {n:"테라뷰",c:"950250",m:"KQ"},
  {n:"테라사이언스",c:"073640",m:"KQ"},
  {n:"테라젠이텍스",c:"066700",m:"KQ"},
  {n:"테스",c:"095610",m:"KQ"},
  {n:"테이팩스",c:"055490",m:"KS"},
  {n:"테크엘",c:"064520",m:"KQ"},
  {n:"테크윙",c:"089030",m:"KQ"},
  {n:"텔레칩스",c:"054450",m:"KQ"},
  {n:"텔코웨어",c:"078000",m:"KS"},
  {n:"텔콘RF제약",c:"200230",m:"KQ"},
  {n:"토니모리",c:"214420",m:"KS"},
  {n:"토마토시스템",c:"393210",m:"KQ"},
  {n:"토모큐브",c:"475960",m:"KQ"},
  {n:"토박스코리아",c:"215480",m:"KQ"},
  {n:"토비스",c:"051360",m:"KQ"},
  {n:"토탈소프트",c:"045340",m:"KQ"},
  {n:"톱텍",c:"108230",m:"KQ"},
  {n:"투비소프트",c:"079970",m:"KQ"},
  {n:"툴젠",c:"199800",m:"KQ"},
  {n:"트루엔",c:"417790",m:"KQ"},
  {n:"트리니티항공",c:"091810",m:"KS"},
  {n:"트윔",c:"290090",m:"KQ"},
  {n:"특수건설",c:"026150",m:"KQ"},
  {n:"티디에스팜",c:"464280",m:"KQ"},
  {n:"티로보틱스",c:"117730",m:"KQ"},
  {n:"티비씨",c:"033830",m:"KQ"},
  {n:"티사이언티픽",c:"057680",m:"KQ"},
  {n:"티쓰리",c:"204610",m:"KQ"},
  {n:"티씨머티리얼즈",c:"125020",m:"KQ"},
  {n:"티씨케이",c:"064760",m:"KQ"},
  {n:"티앤알바이오팹",c:"246710",m:"KQ"},
  {n:"티앤엘",c:"340570",m:"KQ"},
  {n:"티에스넥스젠",c:"043220",m:"KQ"},
  {n:"티에스아이",c:"277880",m:"KQ"},
  {n:"티에스이",c:"131290",m:"KQ"},
  {n:"티에이치엔",c:"019180",m:"KS"},
  {n:"티에프이",c:"425420",m:"KQ"},
  {n:"티엑스알로보틱스",c:"484810",m:"KQ"},
  {n:"티엔엔터테인먼트",c:"131100",m:"KQ"},
  {n:"티엘비",c:"356860",m:"KQ"},
  {n:"티엠씨",c:"217590",m:"KS"},
  {n:"티와이홀딩스",c:"363280",m:"KS"},
  {n:"티와이홀딩스우",c:"36328K",m:"KS"},
  {n:"티움바이오",c:"321550",m:"KQ"},
  {n:"티웨이홀딩스",c:"004870",m:"KS"},
  {n:"티이엠씨",c:"425040",m:"KQ"},
  {n:"티이엠씨씨엔에스",c:"241790",m:"KQ"},
  {n:"티케이지애강",c:"022220",m:"KQ"},
  {n:"티케이케미칼",c:"104480",m:"KQ"},
  {n:"티플랙스",c:"081150",m:"KQ"},
  {n:"티피씨글로벌",c:"130740",m:"KQ"},
  {n:"팅크웨어",c:"084730",m:"KQ"},
  {n:"파두",c:"440110",m:"KQ"},
  {n:"파라다이스",c:"034230",m:"KS"},
  {n:"파라택시스이더리움",c:"290560",m:"KQ"},
  {n:"파라택시스코리아",c:"288330",m:"KQ"},
  {n:"파라텍",c:"033540",m:"KQ"},
  {n:"파로스아이바이오",c:"388870",m:"KQ"},
  {n:"파루",c:"043200",m:"KQ"},
  {n:"파마리서치",c:"214450",m:"KQ"},
  {n:"파미셀",c:"005690",m:"KS"},
  {n:"파버나인",c:"177830",m:"KQ"},
  {n:"파세코",c:"037070",m:"KQ"},
  {n:"파수AI",c:"150900",m:"KQ"},
  {n:"파워넷",c:"037030",m:"KQ"},
  {n:"파워로직스",c:"047310",m:"KQ"},
  {n:"파이버프로",c:"368770",m:"KQ"},
  {n:"파이오링크",c:"170790",m:"KQ"},
  {n:"파이온엑스",c:"900100",m:"KQ"},
  {n:"파인디앤씨",c:"049120",m:"KQ"},
  {n:"파인디지털",c:"038950",m:"KQ"},
  {n:"파인메딕스",c:"387570",m:"KQ"},
  {n:"파인엠텍",c:"441270",m:"KQ"},
  {n:"파인테크닉스",c:"106240",m:"KQ"},
  {n:"파인텍",c:"131760",m:"KQ"},
  {n:"파커스",c:"065690",m:"KQ"},
  {n:"파크시스템스",c:"140860",m:"KQ"},
  {n:"파트론",c:"091700",m:"KQ"},
  {n:"판타지오",c:"032800",m:"KQ"},
  {n:"팜스빌",c:"318010",m:"KQ"},
  {n:"팜스코",c:"036580",m:"KS"},
  {n:"팜스토리",c:"027710",m:"KQ"},
  {n:"팜젠사이언스",c:"004720",m:"KS"},
  {n:"패션플랫폼",c:"225590",m:"KQ"},
  {n:"팬스타엔터프라이즈",c:"054300",m:"KQ"},
  {n:"팬엔터테인먼트",c:"068050",m:"KQ"},
  {n:"팬오션",c:"028670",m:"KS"},
  {n:"팬젠",c:"222110",m:"KQ"},
  {n:"팸텍",c:"271830",m:"KQ"},
  {n:"퍼스텍",c:"010820",m:"KS"},
  {n:"퍼시스",c:"016800",m:"KS"},
  {n:"펄어비스",c:"263750",m:"KQ"},
  {n:"펌텍코리아",c:"251970",m:"KQ"},
  {n:"페니트리움바이오",c:"187660",m:"KQ"},
  {n:"페스카로",c:"0015S0",m:"KQ"},
  {n:"페이퍼코리아",c:"001020",m:"KS"},
  {n:"펨트론",c:"168360",m:"KQ"},
  {n:"펩트론",c:"087010",m:"KQ"},
  {n:"평화산업",c:"090080",m:"KS"},
  {n:"평화홀딩스",c:"010770",m:"KS"},
  {n:"포니링크",c:"064800",m:"KQ"},
  {n:"포메탈",c:"119500",m:"KQ"},
  {n:"포바이포",c:"389140",m:"KQ"},
  {n:"포스뱅크",c:"105760",m:"KQ"},
  {n:"포스코DX",c:"022100",m:"KS"},
  {n:"포스코스틸리온",c:"058430",m:"KS"},
  {n:"포스코엠텍",c:"009520",m:"KQ"},
  {n:"포스코인터내셔널",c:"047050",m:"KS"},
  {n:"포스코퓨처엠",c:"003670",m:"KS"},
  {n:"포시에스",c:"189690",m:"KQ"},
  {n:"포인트모바일",c:"318020",m:"KQ"},
  {n:"포인트엔지니어링",c:"256630",m:"KQ"},
  {n:"포커스에이아이",c:"331380",m:"KQ"},
  {n:"포톤",c:"208710",m:"KQ"},
  {n:"폰드그룹",c:"472850",m:"KQ"},
  {n:"폴라리스AI",c:"039980",m:"KQ"},
  {n:"폴라리스AI파마",c:"041910",m:"KQ"},
  {n:"폴라리스AI핸디",c:"220180",m:"KQ"},
  {n:"폴라리스세원",c:"234100",m:"KQ"},
  {n:"폴라리스오피스",c:"041020",m:"KQ"},
  {n:"폴라리스우노",c:"114630",m:"KQ"},
  {n:"폴레드",c:"487580",m:"KQ"},
  {n:"푸드나무",c:"290720",m:"KQ"},
  {n:"푸드웰",c:"005670",m:"KQ"},
  {n:"푸른로보틱스",c:"094940",m:"KQ"},
  {n:"푸른저축은행",c:"007330",m:"KQ"},
  {n:"풀무원",c:"017810",m:"KS"},
  {n:"풍강",c:"093380",m:"KQ"},
  {n:"풍국주정",c:"023900",m:"KQ"},
  {n:"풍산",c:"103140",m:"KS"},
  {n:"풍산홀딩스",c:"005810",m:"KS"},
  {n:"풍원정밀",c:"371950",m:"KQ"},
  {n:"풍전약품",c:"298060",m:"KQ"},
  {n:"퓨런티어",c:"370090",m:"KQ"},
  {n:"퓨릿",c:"445180",m:"KQ"},
  {n:"퓨쳐켐",c:"220100",m:"KQ"},
  {n:"프럼파스트",c:"035200",m:"KQ"},
  {n:"프레스티지바이오로직스",c:"334970",m:"KQ"},
  {n:"프레스티지바이오파마",c:"950210",m:"KS"},
  {n:"프로이천",c:"321260",m:"KQ"},
  {n:"프로텍",c:"053610",m:"KQ"},
  {n:"프로티나",c:"468530",m:"KQ"},
  {n:"프로티아",c:"303360",m:"KQ"},
  {n:"프롬바이오",c:"377220",m:"KQ"},
  {n:"프리시젼바이오",c:"335810",m:"KQ"},
  {n:"프리엠스",c:"053160",m:"KQ"},
  {n:"프리티",c:"006490",m:"KS"},
  {n:"플라즈맵",c:"405000",m:"KQ"},
  {n:"플래스크",c:"041590",m:"KQ"},
  {n:"플래티어",c:"367000",m:"KQ"},
  {n:"플랜티넷",c:"075130",m:"KQ"},
  {n:"플레이그램",c:"009810",m:"KS"},
  {n:"플레이디",c:"237820",m:"KQ"},
  {n:"플레이위드",c:"023770",m:"KQ"},
  {n:"플리토",c:"300080",m:"KQ"},
  {n:"피노",c:"033790",m:"KQ"},
  {n:"피델릭스",c:"032580",m:"KQ"},
  {n:"피스피스스튜디오",c:"0117P0",m:"KQ"},
  {n:"피씨디렉트",c:"051380",m:"KQ"},
  {n:"피씨엘",c:"241820",m:"KQ"},
  {n:"피아이이",c:"452450",m:"KQ"},
  {n:"피앤씨테크",c:"237750",m:"KQ"},
  {n:"피앤에스로보틱스",c:"460940",m:"KQ"},
  {n:"피에스케이",c:"319660",m:"KQ"},
  {n:"피에스케이홀딩스",c:"031980",m:"KQ"},
  {n:"피에스텍",c:"002230",m:"KQ"},
  {n:"피에이치에이",c:"043370",m:"KQ"},
  {n:"피엔에이치테크",c:"239890",m:"KQ"},
  {n:"피엔케이피부임상연구센타",c:"347740",m:"KQ"},
  {n:"피엔티",c:"137400",m:"KQ"},
  {n:"피엔티엠에스",c:"257370",m:"KQ"},
  {n:"피엠티",c:"147760",m:"KQ"},
  {n:"피제이메탈",c:"128660",m:"KQ"},
  {n:"피제이전자",c:"006140",m:"KQ"},
  {n:"피코그램",c:"376180",m:"KQ"},
  {n:"피플바이오",c:"304840",m:"KQ"},
  {n:"픽셀플러스",c:"087600",m:"KQ"},
  {n:"핀텔",c:"291810",m:"KQ"},
  {n:"필에너지",c:"378340",m:"KQ"},
  {n:"필옵틱스",c:"161580",m:"KQ"},
  {n:"핌스",c:"347770",m:"KQ"},
  {n:"핑거",c:"163730",m:"KQ"},
  {n:"핑거스토리",c:"417180",m:"KQ"},
  {n:"하나31호스팩",c:"469900",m:"KQ"},
  {n:"하나32호스팩",c:"475240",m:"KQ"},
  {n:"하나33호스팩",c:"475250",m:"KQ"},
  {n:"하나34호스팩",c:"484130",m:"KQ"},
  {n:"하나35호스팩",c:"0041L0",m:"KQ"},
  {n:"하나36호스팩",c:"0101C0",m:"KQ"},
  {n:"하나금융지주",c:"086790",m:"KS"},
  {n:"하나기술",c:"299030",m:"KQ"},
  {n:"하나마이크론",c:"067310",m:"KQ"},
  {n:"하나머티리얼즈",c:"166090",m:"KQ"},
  {n:"하나제약",c:"293480",m:"KS"},
  {n:"하나투어",c:"039130",m:"KS"},
  {n:"하림",c:"136480",m:"KQ"},
  {n:"하림지주",c:"003380",m:"KQ"},
  {n:"하스",c:"450330",m:"KQ"},
  {n:"하이드로리튬",c:"101670",m:"KQ"},
  {n:"하이딥",c:"365590",m:"KQ"},
  {n:"하이로닉",c:"149980",m:"KQ"},
  {n:"하이록코리아",c:"013030",m:"KQ"},
  {n:"하이브",c:"352820",m:"KS"},
  {n:"하이비젼시스템",c:"126700",m:"KQ"},
  {n:"하이스틸",c:"071090",m:"KS"},
  {n:"하이젠알앤엠",c:"160190",m:"KQ"},
  {n:"하이즈항공",c:"221840",m:"KQ"},
  {n:"하이텍팜",c:"106190",m:"KQ"},
  {n:"하이트진로",c:"000080",m:"KS"},
  {n:"하이트진로2우B",c:"000087",m:"KS"},
  {n:"하이트진로홀딩스",c:"000140",m:"KS"},
  {n:"하이트진로홀딩스우",c:"000145",m:"KS"},
  {n:"하이퍼코퍼레이션",c:"065650",m:"KQ"},
  {n:"하츠",c:"066130",m:"KQ"},
  {n:"한국가구",c:"004590",m:"KQ"},
  {n:"한국가스공사",c:"036460",m:"KS"},
  {n:"한국경제TV",c:"039340",m:"KQ"},
  {n:"한국공항",c:"005430",m:"KS"},
  {n:"한국금융지주",c:"071050",m:"KS"},
  {n:"한국금융지주우",c:"071055",m:"KS"},
  {n:"한국기업평가",c:"034950",m:"KQ"},
  {n:"한국내화",c:"010040",m:"KS"},
  {n:"한국단자",c:"025540",m:"KS"},
  {n:"한국맥널티",c:"222980",m:"KQ"},
  {n:"한국무브넥스",c:"010100",m:"KS"},
  {n:"한국비엔씨",c:"256840",m:"KQ"},
  {n:"한국비티비",c:"219750",m:"KQ"},
  {n:"한국석유",c:"004090",m:"KS"},
  {n:"한국선재",c:"025550",m:"KQ"},
  {n:"한국수출포장",c:"002200",m:"KS"},
  {n:"한국쉘석유",c:"002960",m:"KS"},
  {n:"한국알콜",c:"017890",m:"KQ"},
  {n:"한국앤컴퍼니",c:"000240",m:"KS"},
  {n:"한국유니온제약",c:"080720",m:"KQ"},
  {n:"한국자산신탁",c:"123890",m:"KS"},
  {n:"한국전력",c:"015760",m:"KS"},
  {n:"한국전자인증",c:"041460",m:"KQ"},
  {n:"한국전자홀딩스",c:"006200",m:"KS"},
  {n:"한국정밀기계",c:"101680",m:"KQ"},
  {n:"한국정보공학",c:"039740",m:"KQ"},
  {n:"한국정보인증",c:"053300",m:"KQ"},
  {n:"한국정보통신",c:"025770",m:"KQ"},
  {n:"한국제15호스팩",c:"479880",m:"KQ"},
  {n:"한국제16호스팩",c:"0164H0",m:"KQ"},
  {n:"한국제지",c:"027970",m:"KS"},
  {n:"한국종합기술",c:"023350",m:"KS"},
  {n:"한국주강",c:"025890",m:"KS"},
  {n:"한국주철관",c:"000970",m:"KS"},
  {n:"한국철강",c:"104700",m:"KS"},
  {n:"한국첨단소재",c:"062970",m:"KQ"},
  {n:"한국카본",c:"017960",m:"KS"},
  {n:"한국캐피탈",c:"023760",m:"KQ"},
  {n:"한국컴퓨터",c:"054040",m:"KQ"},
  {n:"한국콜마",c:"161890",m:"KS"},
  {n:"한국큐빅",c:"021650",m:"KQ"},
  {n:"한국타이어앤테크놀로지",c:"161390",m:"KS"},
  {n:"한국토지신탁",c:"034830",m:"KS"},
  {n:"한국특강",c:"007280",m:"KS"},
  {n:"한국파마",c:"032300",m:"KQ"},
  {n:"한국팩키지",c:"037230",m:"KQ"},
  {n:"한국피아이엠",c:"448900",m:"KQ"},
  {n:"한국항공우주",c:"047810",m:"KS"},
  {n:"한국화장품",c:"123690",m:"KS"},
  {n:"한국화장품제조",c:"003350",m:"KS"},
  {n:"한네트",c:"052600",m:"KQ"},
  {n:"한농화성",c:"011500",m:"KS"},
  {n:"한독",c:"002390",m:"KS"},
  {n:"한독크린텍",c:"256150",m:"KQ"},
  {n:"한라IMS",c:"092460",m:"KQ"},
  {n:"한라캐스트",c:"125490",m:"KQ"},
  {n:"한미글로벌",c:"053690",m:"KS"},
  {n:"한미반도체",c:"042700",m:"KS"},
  {n:"한미사이언스",c:"008930",m:"KS"},
  {n:"한미약품",c:"128940",m:"KS"},
  {n:"한빛레이저",c:"452190",m:"KQ"},
  {n:"한빛소프트",c:"047080",m:"KQ"},
  {n:"한샘",c:"009240",m:"KS"},
  {n:"한선엔지니어링",c:"452280",m:"KQ"},
  {n:"한섬",c:"020000",m:"KS"},
  {n:"한성기업",c:"003680",m:"KS"},
  {n:"한성크린텍",c:"066980",m:"KQ"},
  {n:"한세실업",c:"105630",m:"KS"},
  {n:"한세엠케이",c:"069640",m:"KS"},
  {n:"한세예스24홀딩스",c:"016450",m:"KS"},
  {n:"한솔로지스틱스",c:"009180",m:"KS"},
  {n:"한솔아이원스",c:"114810",m:"KQ"},
  {n:"한솔제지",c:"213500",m:"KS"},
  {n:"한솔케미칼",c:"014680",m:"KS"},
  {n:"한솔테크닉스",c:"004710",m:"KS"},
  {n:"한솔홀딩스",c:"004150",m:"KS"},
  {n:"한솔홈데코",c:"025750",m:"KS"},
  {n:"한스바이오메드",c:"042520",m:"KQ"},
  {n:"한신공영",c:"004960",m:"KS"},
  {n:"한신기계",c:"011700",m:"KS"},
  {n:"한싹",c:"430690",m:"KQ"},
  {n:"한양디지텍",c:"078350",m:"KQ"},
  {n:"한양이엔지",c:"045100",m:"KQ"},
  {n:"한양증권",c:"001750",m:"KS"},
  {n:"한양증권우",c:"001755",m:"KS"},
  {n:"한온시스템",c:"018880",m:"KS"},
  {n:"한올바이오파마",c:"009420",m:"KS"},
  {n:"한울반도체",c:"320000",m:"KQ"},
  {n:"한울소재과학",c:"091440",m:"KQ"},
  {n:"한울앤제주",c:"276730",m:"KQ"},
  {n:"한익스프레스",c:"014130",m:"KS"},
  {n:"한일단조",c:"024740",m:"KQ"},
  {n:"한일사료",c:"005860",m:"KQ"},
  {n:"한일시멘트",c:"300720",m:"KS"},
  {n:"한일철강",c:"002220",m:"KS"},
  {n:"한일홀딩스",c:"003300",m:"KS"},
  {n:"한일화학",c:"007770",m:"KQ"},
  {n:"한전KPS",c:"051600",m:"KS"},
  {n:"한전기술",c:"052690",m:"KS"},
  {n:"한전산업",c:"130660",m:"KS"},
  {n:"한주라이트메탈",c:"198940",m:"KQ"},
  {n:"한주에이알티",c:"058450",m:"KQ"},
  {n:"한중엔시에스",c:"107640",m:"KQ"},
  {n:"한진",c:"002320",m:"KS"},
  {n:"한진중공업홀딩스",c:"003480",m:"KS"},
  {n:"한진칼",c:"180640",m:"KS"},
  {n:"한진칼우",c:"18064K",m:"KS"},
  {n:"한창",c:"005110",m:"KS"},
  {n:"한창산업",c:"079170",m:"KQ"},
  {n:"한창제지",c:"009460",m:"KS"},
  {n:"한컴",c:"030520",m:"KQ"},
  {n:"한컴라이프케어",c:"372910",m:"KS"},
  {n:"한컴위드",c:"054920",m:"KQ"},
  {n:"한켐",c:"457370",m:"KQ"},
  {n:"한탑",c:"002680",m:"KQ"},
  {n:"한텍",c:"098070",m:"KQ"},
  {n:"한패스",c:"408470",m:"KQ"},
  {n:"한화",c:"000880",m:"KS"},
  {n:"한화3우B",c:"00088K",m:"KS"},
  {n:"한화갤러리아",c:"452260",m:"KS"},
  {n:"한화갤러리아우",c:"45226K",m:"KS"},
  {n:"한화리츠",c:"451800",m:"KS"},
  {n:"한화비전",c:"489790",m:"KS"},
  {n:"한화생명",c:"088350",m:"KS"},
  {n:"한화손해보험",c:"000370",m:"KS"},
  {n:"한화솔루션",c:"009830",m:"KS"},
  {n:"한화솔루션우",c:"009835",m:"KS"},
  {n:"한화시스템",c:"272210",m:"KS"},
  {n:"한화에어로스페이스",c:"012450",m:"KS"},
  {n:"한화엔진",c:"082740",m:"KS"},
  {n:"한화오션",c:"042660",m:"KS"},
  {n:"한화투자증권",c:"003530",m:"KS"},
  {n:"한화투자증권우",c:"003535",m:"KS"},
  {n:"한화플러스제5호스팩",c:"498390",m:"KQ"},
  {n:"해성디에스",c:"195870",m:"KS"},
  {n:"해성산업",c:"034810",m:"KQ"},
  {n:"해성산업1우",c:"03481K",m:"KQ"},
  {n:"해성에어로보틱스",c:"059270",m:"KQ"},
  {n:"해성옵틱스",c:"076610",m:"KQ"},
  {n:"해태제과식품",c:"101530",m:"KS"},
  {n:"핸즈코퍼레이션",c:"143210",m:"KS"},
  {n:"헝셩그룹",c:"900270",m:"KQ"},
  {n:"헥토이노베이션",c:"214180",m:"KQ"},
  {n:"헥토파이낸셜",c:"234340",m:"KQ"},
  {n:"헬릭스미스",c:"084990",m:"KQ"},
  {n:"현대건설",c:"000720",m:"KS"},
  {n:"현대건설우",c:"000725",m:"KS"},
  {n:"현대공업",c:"170030",m:"KQ"},
  {n:"현대그린푸드",c:"453340",m:"KS"},
  {n:"현대글로비스",c:"086280",m:"KS"},
  {n:"현대로템",c:"064350",m:"KS"},
  {n:"현대리바트",c:"079430",m:"KS"},
  {n:"현대모비스",c:"012330",m:"KS"},
  {n:"현대무벡스",c:"319400",m:"KQ"},
  {n:"현대바이오",c:"048410",m:"KQ"},
  {n:"현대바이오랜드",c:"052260",m:"KQ"},
  {n:"현대백화점",c:"069960",m:"KS"},
  {n:"현대비앤지스틸",c:"004560",m:"KS"},
  {n:"현대사료",c:"016790",m:"KQ"},
  {n:"현대약품",c:"004310",m:"KS"},
  {n:"현대에버다임",c:"041440",m:"KQ"},
  {n:"현대에이치티",c:"039010",m:"KQ"},
  {n:"현대엘리베이터",c:"017800",m:"KS"},
  {n:"현대오토에버",c:"307950",m:"KS"},
  {n:"현대위아",c:"011210",m:"KS"},
  {n:"현대이지웰",c:"090850",m:"KQ"},
  {n:"현대제철",c:"004020",m:"KS"},
  {n:"현대지에프홀딩스",c:"005440",m:"KS"},
  {n:"현대차",c:"005380",m:"KS"},
  {n:"현대차2우B",c:"005387",m:"KS"},
  {n:"현대차3우B",c:"005389",m:"KS"},
  {n:"현대차우",c:"005385",m:"KS"},
  {n:"현대차증권",c:"001500",m:"KS"},
  {n:"현대코퍼레이션",c:"011760",m:"KS"},
  {n:"현대코퍼레이션홀딩스",c:"227840",m:"KS"},
  {n:"현대퓨처넷",c:"126560",m:"KS"},
  {n:"현대해상",c:"001450",m:"KS"},
  {n:"현대힘스",c:"460930",m:"KQ"},
  {n:"현우산업",c:"092300",m:"KQ"},
  {n:"형지I&C",c:"011080",m:"KQ"},
  {n:"형지글로벌",c:"308100",m:"KQ"},
  {n:"형지엘리트",c:"093240",m:"KS"},
  {n:"혜인",c:"003010",m:"KS"},
  {n:"호전실업",c:"111110",m:"KS"},
  {n:"호텔신라",c:"008770",m:"KS"},
  {n:"호텔신라우",c:"008775",m:"KS"},
  {n:"홈캐스트",c:"064240",m:"KQ"},
  {n:"화성밸브",c:"039610",m:"KQ"},
  {n:"화승알앤에이",c:"378850",m:"KS"},
  {n:"화승엔터프라이즈",c:"241590",m:"KS"},
  {n:"화승인더",c:"006060",m:"KS"},
  {n:"화승코퍼레이션",c:"013520",m:"KS"},
  {n:"화신",c:"010690",m:"KS"},
  {n:"화신정공",c:"126640",m:"KQ"},
  {n:"화인베스틸",c:"133820",m:"KS"},
  {n:"화인써키트",c:"127980",m:"KQ"},
  {n:"화일약품",c:"061250",m:"KQ"},
  {n:"화천기계",c:"010660",m:"KS"},
  {n:"화천기공",c:"000850",m:"KS"},
  {n:"환인제약",c:"016580",m:"KS"},
  {n:"황금에스티",c:"032560",m:"KS"},
  {n:"효성",c:"004800",m:"KS"},
  {n:"효성ITX",c:"094280",m:"KS"},
  {n:"효성오앤비",c:"097870",m:"KQ"},
  {n:"효성중공업",c:"298040",m:"KS"},
  {n:"효성티앤씨",c:"298020",m:"KS"},
  {n:"효성화학",c:"298000",m:"KS"},
  {n:"후성",c:"093370",m:"KS"},
  {n:"휴네시온",c:"290270",m:"KQ"},
  {n:"휴니드",c:"005870",m:"KS"},
  {n:"휴럼",c:"353190",m:"KQ"},
  {n:"휴림로봇",c:"090710",m:"KQ"},
  {n:"휴림에이텍",c:"078590",m:"KQ"},
  {n:"휴마시스",c:"205470",m:"KQ"},
  {n:"휴맥스",c:"115160",m:"KQ"},
  {n:"휴맥스홀딩스",c:"028080",m:"KQ"},
  {n:"휴메딕스",c:"200670",m:"KQ"},
  {n:"휴비스",c:"079980",m:"KS"},
  {n:"휴비츠",c:"065510",m:"KQ"},
  {n:"휴스틸",c:"005010",m:"KS"},
  {n:"휴엠앤씨",c:"263920",m:"KQ"},
  {n:"휴온스",c:"243070",m:"KQ"},
  {n:"휴온스글로벌",c:"084110",m:"KQ"},
  {n:"휴젤",c:"145020",m:"KQ"},
  {n:"흥구석유",c:"024060",m:"KQ"},
  {n:"흥국",c:"010240",m:"KQ"},
  {n:"흥국에프엔비",c:"189980",m:"KQ"},
  {n:"흥국화재",c:"000540",m:"KS"},
  {n:"흥국화재우",c:"000545",m:"KS"},
  {n:"흥아해운",c:"003280",m:"KS"},
  {n:"희림",c:"037440",m:"KQ"},
  {n:"힘스",c:"238490",m:"KQ"},
];

// 잘린 이름을 몇 글자까지 복원할지.
// 키움 잔고는 글자 수가 아니라 표시 폭(한글 5자 = 영문 10자)으로 자른다.
// "SK아이이테크놀로지"→"SK아이이테"처럼 긴 이름은 4~6자가 잘리므로 3은 너무 좁았다.
//
// 넓히는 게 위험해 보이지만 측정 결과는 반대다. 캡이 좁으면 진짜 경쟁 후보가
// 후보 목록에서 빠져 유일해져 버리고, 그래서 "틀린 코드"가 들어간다.
// (예: "HD현대마" → HD현대마린솔루션이 캡 밖이라 HD현대마린엔진으로 확정)
// 마스터 전 종목을 4~7자로 잘라 돌린 결과 — 캡 3: 오매칭 20/7/1/1건,
// 캡 8: 전 구간 오매칭 0건, 정확 복원은 오히려 증가.
const MAX_TRUNCATED_CHARS = 8;

const norm = (s) => String(s || "").trim().toLowerCase().replace(/\s+/g, "");

// 알파벳 한 글자의 한글 읽기. 단일주식선물 종목명은 앞머리 영문을 소리나는
// 대로 적어 온다("SK아이이테크놀로지" → "에스케이아이이테크놀로지").
const LATIN_KO = {
  a:"에이", b:"비", c:"씨", d:"디", e:"이", f:"에프", g:"지", h:"에이치",
  i:"아이", j:"제이", k:"케이", l:"엘", m:"엠", n:"엔", o:"오", p:"피",
  q:"큐", r:"알", s:"에스", t:"티", u:"유", v:"브이", w:"더블유", x:"엑스",
  y:"와이", z:"제트",
};

// 앞머리 영문 구간만 한글로 바꾼 이름. 영문으로 시작하지 않으면 null.
// 앞머리에만 적용하는 게 중요하다 — 전체 치환이면 "피에스케이"(PSK)가
// "피SK"가 되어 멀쩡하던 이름이 깨진다.
// 한계: 약어만 다룬다. NAVER·POSCO·S-Oil처럼 단어로 읽는 이름은 글자별
// 읽기("엔에이브이이알")가 실제 발음과 달라 음차 조회가 안 된다.
function koPhonetic(s) {
  const m = /^[a-z&]+/.exec(s);         // KT&G의 &는 "앤"으로 읽는다
  if (!m) return null;
  let ko = "";
  for (const ch of m[0]) ko += ch === "&" ? "앤" : LATIN_KO[ch];
  return ko + s.slice(m[0].length);
}

// 검색 키 → 종목. 정식 표기(p=false)와 음차 표기(p=true)를 한 테이블에 담아
// 조회 함수들이 표기 차이를 신경 쓰지 않게 한다.
// 음차 키가 다른 종목의 정식 표기와 겹치면 그 키는 버린다(오매칭 방지).
const ALIASES = (() => {
  const canon = new Set(KR_STOCKS.map((it) => norm(it.n)));
  const out = KR_STOCKS.map((it) => ({ k: norm(it.n), it, p: false }));
  for (const it of KR_STOCKS) {
    const ph = koPhonetic(norm(it.n));
    if (ph && !canon.has(ph)) out.push({ k: ph, it, p: true });
  }
  return out;
})();

/**
 * 끝이 잘린 종목명 → {n,c,m}. 잘린 이름을 접두사로 보고 마스터에서 찾는다.
 * 후보가 둘 이상이면(예: "삼성전" → 삼성전자·삼성전기·삼성전자우) null을
 * 돌려주고 추측하지 않는다 — 틀린 코드는 시세와 손익을 통째로 망친다.
 *
 * preferCommon: 후보가 보통주/우선주로만 갈릴 때 보통주를 고른다.
 * "한화솔루"는 한화솔루션과 한화솔루션우 둘 다에 걸리는데, 이 마스터에서
 * 끝자리가 0이 아닌 코드 30개는 전부 우선주고 예외가 되는 보통주는 없다.
 * 단, "LG전자우"가 "LG전"으로 잘린 경우도 보통주로 가버리므로 정보가
 * 실제로 소실된 케이스는 못 가린다. 그래서 단일주식선물처럼 보통주에만
 * 상장되는 게 확실한 경로에서만 켠다.
 */
export function findByTruncatedName(name, { preferCommon = false, maxCut = MAX_TRUNCATED_CHARS } = {}) {
  const s = norm(name);
  if (s.length < 2) return null;
  const cand = ALIASES.filter(
    (a) => a.k.startsWith(s) && a.k.length - s.length <= maxCut,
  );
  // 정식 표기가 하나라도 걸리면 음차 후보는 버린다. 안 그러면 마스터에 음차형과
  // 영문형이 같이 있는 짝(아이에스동서/ISC, 케이씨텍/KC…)에서 "아이에스" 같은
  // 잘린 이름이 새로 애매해져, 원래 되던 복원이 null로 죽는다.
  const canonHits = cand.filter((a) => !a.p);
  // 한 종목이 두 키로 잡힐 수 있어 종목 단위로 중복 제거 후 센다
  let hits = [...new Set((canonHits.length ? canonHits : cand).map((a) => a.it))];
  if (preferCommon && hits.length > 1) {
    const common = hits.filter((it) => it.c.endsWith("0"));
    if (common.length) hits = common;
  }
  return hits.length === 1 ? hits[0] : null;
}

// 종목명 → {n,c,m}. 정확 일치(대소문자·공백·음차 표기 무시) → 끝이 잘린 이름
// 복원 순. 티커 자리에 이름이 들어간 경우 코드 자동해석용.
export function findByName(name) {
  const s = norm(name);
  if (!s) return null;
  const hit = ALIASES.find((a) => a.k === s);
  return hit ? hit.it : findByTruncatedName(name);
}

export function searchStocks(q, limit = 8) {
  const s = String(q || "").trim().toLowerCase();
  if (!s) return [];
  const starts = [], contains = [];
  for (const it of KR_STOCKS) {
    const n = it.n.toLowerCase();
    if (n === s || it.c === s) return [it];
    if (n.startsWith(s) || it.c.startsWith(s)) starts.push(it);
    else if (n.includes(s)) contains.push(it);
    if (starts.length >= limit) break;
  }
  return [...starts, ...contains].slice(0, limit);
}
